import React, { Fragment, useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import "./DashBoard.scss";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Checkbox,
  Tab,
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import FlagIcon from "@mui/icons-material/Flag";
import { neutral, primaryColor, error } from "../../constants/colorConstants";
import { DatePicker } from "antd";
import DoubleDonutGraph from "../common/DoubleDoughnut";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Chart from "../common/Chart";
import CircularProgressBar from "../common/CircularProgressBar";
import {
  fetchBusinessUnits,
  getSettingPreferences,
} from "../../services/orgService";
import {
  emissionsByMonthService,
  emissionsByUnitService,
  getEmissionValueTotalService,
  getEmissionByScopeAndMonthService,
  getEmissionsByScopeandCategoriesService,
  getAllEmissionsService,
  emissionAvailableCategoriesService,
  emissionsByYearService,
  getEmissionsData,
  targetsByYearService,
  metricsByYearService,
  metricsService,
  getEmissionCurrencyService,
  getCarbonPriceService,
} from "../../services/emissionService";
import type { Moment } from "moment";
import { dashBoardMessage } from "../../constants/messageConstants";
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";
import { specialRound, graphRoundOff, round, toastMessage } from "../../helper";
import { deepClone } from "@mui/x-data-grid/utils/utils";
import SankeyChart from "../common/SankeyChart";
import { Select as AntSelect } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { CATEGORY_CODE, CURRENCY, TARGET_TYPES } from "../../constants/enums";
import { useTranslation } from "react-i18next";
import { getTargetService } from "../../services/targetService";
import { useSearchParams } from "react-router-dom";
import {
  getOffsetsByMonth,
  getOffsetsByYear,
} from "../../services/offsetService";
import DashboardSkeleton from "../common/DashboardSkeleton/DashboardSkeleton";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { getSupplierAllocatedEmissions } from "../../services/srmService";

const { Option } = AntSelect;

let targetsByYearData: any = [];

const progressColor = ["#F7BA1E", primaryColor, "#5293E9"];

const scopeMap: any = {
  "Direct emissions": "Scope 1",
  "Indirect emissions from purchased energy": "Scope 2",
  "Other indirect emissions": "Scope 3",
};

const noEmissionObject = {
  category: "--",
  emissionvalue: 0.0,
  name: "--",
  progress: "0",
  scope: "--",
};

const getRoundOff = (value: any) => {
  const val = graphRoundOff(value);
  const roundedValue = round(val[0]);
  if (roundedValue === "0.00") {
    return 0;
  } else {
    return value === 0 ? 0 : roundedValue + val[1];
  }
};

const cat41Map: any = {
  iso: {
    code: "Category 4.1",
    id: 23,
    parent: 7,
  },
  ghg: {
    code: "Scope 3.1",
    id: 86,
    parent: 72,
  },
};

const getUOMValue = (value: number, currUnit: any, selectedUOM: any) => {
  if (currUnit === selectedUOM) {
    return getRoundOff(value);
  }
  let newValue;
  if (currUnit === "t CO2e") {
    newValue = value * 1000;
  } else {
    newValue = value / 1000;
  }
  return getRoundOff(newValue);
};

const ShowNoData = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="pw-empty-page flex flex-col h-30v w-full justify-center items-center gap-1">
      <img className="pw-no-items" alt=" " src="assets/images/Mask.png" />
      <div className="text-sm font-bold">{t("No data")}</div>
      <div className="pw-bunit-desc text-sm text-neutral-500">
        {t("No data found matching your selected filters")}
      </div>
    </div>
  );
};
const createHTMLToolTip = (category: any = null) => {
  return (
    "<div>" +
    '<div><span style="font-weight:700;margin-right:20px">Category 1</span> <span>Direct ghg emnissions and Removal in tonnes</span></div>' +
    '<div> <span style="font-weight:600;margin-right:20px">45.67 tco2 </span> <span>20% </span> </div>' +
    "</div>"
  );
};

const scopeColors: any = {
  "Scope 1": "color: rgb(237,187,94,0.2)",
  "Scope 2": "color: rgb(89,205,143,0.2)",
  "Scope 3": "color: rgb(84,150,239,0.2)",
};
const InputStyle = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    border: "none",
    //height: "2rem !important",
    fontSize: "14px",
  },
}));

function DashBoard() {
  const { t, i18n } = useTranslation();
  // const [searchParams, setSearchParams] = useSearchParams();
  // useEffect(() => {
  //   if (searchParams.has("cardUpdated")) {
  //     // searchParams.delete("cardUpdated");
  //     // searchParams.has("hostedpage_id") && searchParams.delete("hostedpage_id");
  //     toastMessage(
  //       "The card details have been successfully updated. Please wait for a while as we proceed to associate it with your subscription.",
  //       "success"
  //     );
  //     setSearchParams(searchParams);
  //   }
  // }, []);
  const [scope, setScope] = React.useState("4");
  const [selectedUOM, setselectedUOM] = useState("t CO2e");
  const [isLoading, setIsLoading] = useState(true);
  const [totalEmission, setTotalEmission] = useState({
    total_emission_value: 0,
    uom: "",
    conversion_value: 0,
    categories: [
      {
        name: "",
        category: "",
        value: "0 Kg CO2e",
        progress: "0",
      },
      {
        name: "",
        category: "",
        value: "0 Kg CO2e",
        progress: "0",
      },
    ],
  });
  const [totalOffsetValue, setTotalOffsetValue] = useState({
    totalValue: 0,
    tco2e: 0,
    mwh: 0,
  } as any);
  const [topThreeEmissions, setTopThreeEmissions] = useState([] as any);
  const [totalTreeEmission, setTotalTreeEmission] = useState({
    total_emission_value: 0,
  });
  type RangeValue = [Moment | null, Moment | null] | null;
  const [series1, setSeries1] = useState([]); //y-axis
  const [categories1, setCategories1] = useState([]); //x-axis
  const [series2, setSeries2] = useState([]);
  const [categories2, setCategories2] = useState([]);
  const [data3, setData3] = useState([]);
  const [series4, setSeries4] = useState([]);
  const [categories4, setCategories4] = useState([]);
  const [emissionByMonth, setEmissionByMonth] = useState({} as any);
  const [yearsMap, setYearsMap] = useState<any>({});
  const [openCurrencyDropdown, setOpenCureencyDropDown] = useState(false);
  const [currentTab, setCurrentTab] = useState("1");
  const [currentTabName, setCurrentTabName] = useState("Facility");
  const [scopeType, setScopeType] = useState<string | undefined>(undefined);
  const [categoryType, setCategoryType] = useState<string | undefined>(
    undefined
  );
  const [showList, setShowList] = useState(false);

  const extrapolateArray = (targetArray: any, emissionYearArray: any) => {
    let firstValidIndex = -1,
      zeroModeOn = false;
    let lastValidIndex = -1;
    let index = 0;

    if (targetArray.length === 1) {
      targetArray[0] = 0;
      return;
    }
    while (index < targetArray?.length) {
      if (targetArray[index] === undefined) {
        zeroModeOn = true;
        lastValidIndex = -1;
      } else {
        lastValidIndex = index;
        if (!zeroModeOn) {
          firstValidIndex = index;
        }
        if (lastValidIndex > 0 && zeroModeOn) {
          zeroModeOn = false;
          let index2 = firstValidIndex + 1;
          while (index2 < lastValidIndex) {
            targetArray[index2] =
              firstValidIndex === -1
                ? targetArray[lastValidIndex]
                : calculateEstimatedtarget(
                    firstValidIndex,
                    lastValidIndex,
                    index2,
                    emissionYearArray,
                    targetArray[firstValidIndex],
                    targetArray[lastValidIndex]
                  );
            index2++;
          }
          firstValidIndex = lastValidIndex;
        }
      }
      index++;
    }
    targetArray?.length && (targetArray[targetArray?.length - 1] = 0);
    padLeftValues(targetArray);
    for (let index in targetArray) {
      if (targetArray[index] === undefined) {
        targetArray[index] = 0;
      }
    }
  };
  const padLeftValues = (targetArray: any) => {
    let validIndex = -1;
    if (targetArray[0] !== undefined) {
      return;
    }
    for (let eachElem of targetArray) {
      validIndex++;
      if (eachElem !== undefined) {
        break;
      }
    }
    for (let i = 0; i < validIndex; i++) {
      targetArray[i] = targetArray[validIndex];
    }
  };
  const calculateEstimatedtarget = (
    firstValidIndex: number,
    lastValidIndex: number,
    currentIndex: number,
    emissionYearArray: any,
    firstValue: number,
    lastValue: number
  ) => {
    let estValue =
      firstValue -
      ((firstValue - lastValue) *
        (emissionYearArray[currentIndex] -
          emissionYearArray[firstValidIndex])) /
        (emissionYearArray[lastValidIndex] -
          emissionYearArray[firstValidIndex]);
    return estValue;
  };
  const horizontalBarOptions = {
    series: [{ name: "Emissions", data: series4 }],
    options: {
      colors: ["#2D7EE9", primaryColor, "#F7BA1E"],
      title: {
        text: `x-axis: ${selectedUOM}`,
        style: {
          fontSize: "12px",
          fontFamily: "Roboto",
          color: "#8897AE",
          fontWeight: "100",
        },
      },
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          horizontal: true,
          barHeight: "30%",
        },
      },
      tooltip: {
        x: {
          show: true,
        },
        y: {
          formatter: function (value: any) {
            return getUOMValue(value, "kg CO2e", selectedUOM);
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: categories4,
        labels: {
          style: {
            colors: "#8897AE",
          },
          formatter: function (value: any) {
            return getUOMValue(value, "kg CO2e", selectedUOM);
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: "#8897AE",
          },
        },
      },
    },
  };
  const handleScopeChange = (event: any) => {
    setScope(event.target.value as string);
  };
  const { RangePicker } = DatePicker;
  const targetOptionsMixedChart = {
    chart: {
      id: "basic-bar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "50%",
      },
    },
    stroke: {
      width: [4, 0, 0],
    },
    xaxis: {
      categories: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    },
    markers: {
      size: 6,
      strokeWidth: 3,
      fillOpacity: 0,
      strokeOpacity: 0,
      hover: {
        size: 8,
      },
    },
    yaxis: {
      tickAmount: 5,
      min: 0,
      max: 100,
    },
  };
  const targetSeriesMixedChart = [
    {
      name: "Target",
      type: "line",
      data: [],
    },
    {
      name: "Emissions",
      type: "column",
      data: [],
    },
  ];
  const metricsOptionsInitMixedChart = {
    chart: {
      id: "basic-bar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "50%",
      },
    },
    stroke: {
      width: [4, 0, 0],
    },
    xaxis: {
      categories: ["sun"],
    },
    markers: {
      size: 6,
      strokeWidth: 3,
      fillOpacity: 0,
      strokeOpacity: 0,
      hover: {
        size: 8,
      },
    },
    yaxis: {
      tickAmount: 5,
      min: 0,
      max: 100,
    },
  };
  const initMetricsSeriesMixedChart = [
    {
      name: "Target",
      type: "line",
      data: [1],
    },
    {
      name: "Emissions",
      type: "column",
      data: [1],
    },
  ];
  const metricsOptionsMixedChart = {
    chart: {
      id: "basic-bar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "50%",
      },
    },
    stroke: {
      width: [4, 0, 0],
    },
    xaxis: {
      categories: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    },
    markers: {
      size: 6,
      strokeWidth: 3,
      fillOpacity: 0,
      strokeOpacity: 0,
      hover: {
        size: 8,
      },
    },
    yaxis: {
      tickAmount: 5,
      min: 0,
      max: 100,
    },
  };

  const [targetCategories, setTargetCategories] = useState<any>([]);
  const [emissionsData, setEmissionsData] = useState<any>(null);
  const [dataPresent, setDataPresent] = useState<boolean>(false);
  const getTabularData = async () => {
    if (emissionsData == null || !emissionsData?.targets?.length) {
      try {
        if (currentTab !== "1") setTargetCategories([]);
        const years = targetCategories.join(",");
        const targetRes = await getEmissionsData(
          bunitListWithTargets?.length ? targetBunit : null,
          bunitListWithTargets?.length ? years : null
        );
        const targetData = targetRes.data;

        setDataPresent(
          targetData?.targets?.categories?.length ||
            targetData?.targets?.scopes?.length ||
            targetData?.actuals?.categories?.length ||
            targetData?.actuals?.scopes?.length
            ? true
            : false
        );
        setEmissionsData(targetData);

        return targetData;
      } catch (error) {
        console.error("Error fetching emissions data:", error);
      }
    }
  };

  const renderScopeRow = (scopeId: number, scopeName: string) => (
    <TableRow key={scopeId}>
      <TableCell className="!bg-neutral-100 text-slate-700 text-sm font-bold font-['Proxima Nova'] pt-3 pb-2">
        {scopeName} :
      </TableCell>
      <TableCell className="!bg-info-100 " align="right">
        {getUOMValue(
          emissionsData?.actuals.scopes.find(
            (scope: { id: number }) => scope.id === scopeId
          )?.total_value || 0,
          "t CO2e",
          selectedUOM
        )}
      </TableCell>
      <TableCell className="!bg-info-100 " align="right">
        {getUOMValue(
          emissionsData?.targets.scopes.find(
            (scope: { scope: number }) => scope.scope === scopeId
          )?.total_value || 0,
          "t CO2e",
          selectedUOM
        )}
      </TableCell>

      {targetCategories?.map(
        (year: string, index: React.Key | null | undefined) => (
          <React.Fragment key={index}>
            <TableCell className="!bg-neutral-100" align="right">
              {parseInt(year) > new Date().getFullYear()
                ? "-"
                : getUOMValue(
                    emissionsData?.actuals.scopes.find(
                      (scope: { id: number }) => scope.id === scopeId
                    )?.data[
                      year as keyof (typeof emissionsData.actuals.scopes)[0]["data"]
                    ] || 0,
                    "t CO2e",
                    selectedUOM
                  )}
            </TableCell>
            <TableCell className="!bg-neutral-100" align="right">
              {getUOMValue(
                emissionsData?.targets.scopes.find(
                  (scope: { scope: number }) => scope.scope === scopeId
                )?.data[
                  year as keyof (typeof emissionsData.targets.scopes)[0]["data"]
                ] || 0,
                "t CO2e",
                selectedUOM
              )}
            </TableCell>
          </React.Fragment>
        )
      )}
    </TableRow>
  );

  const [targetSeries, setTargetSeries] = useState<any>(targetSeriesMixedChart);
  const targetOptions = {
    options: {
      chart: {
        id: "basic-bar",
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          columnWidth: "50%",
        },
      },
      stroke: {
        width: [4, 0, 0],
      },
      xaxis: {
        // title: {
        //   text: "x-axis: years",
        //   style: {
        //     fontSize: "12px",
        //     fontFamily: "Roboto",
        //     color: "#8897AE",
        //     fontWeight: "100",
        //   },
        // },
        categories: targetCategories,
      },
      markers: {
        size: 6,
        strokeWidth: 3,
        fillOpacity: 0,
        strokeOpacity: 0,
        hover: {
          size: 8,
        },
      },
      yaxis: {
        title: {
          text: `${selectedUOM}`,
          style: {
            fontSize: "10px",
            fontFamily: "Roboto",
            color: "#8897AE",
            fontWeight: "100",
          },
        },
        tickAmount: 5,
        labels: {
          formatter: function (value: any) {
            return getUOMValue(value, "t CO2e", selectedUOM);
          },
          style: {
            colors: "#8897AE",
          },
        },
        // min: 0,
        // max: 100,
      },
    },
    series: targetSeries,
  };
  const [metric, setMetric] = useState("Active employees");
  const [targetUomName, setTargetUomName] = useState("t CO2e/Employee");
  const [metricsCategories, setMetricsCategories] = useState<any>([]);
  const [metricsSeries, setMetricsSeries] = useState<any>(
    targetSeriesMixedChart
  );
  const targetMetricsOptions = {
    options: {
      chart: {
        id: "basic-bar",
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          columnWidth: "50%",
        },
      },
      stroke: {
        width: [4, 0, 0],
      },
      xaxis: {
        categories: metricsCategories,
      },
      markers: {
        size: 6,
        strokeWidth: 3,
        fillOpacity: 0,
        strokeOpacity: 0,
        hover: {
          size: 8,
        },
      },
      yaxis: {
        title: {
          text: targetUomName,
          style: {
            fontSize: "10px",
            fontFamily: "Roboto",
            color: "#8897AE",
            fontWeight: "100",
          },
        },
        labels: {
          formatter: function (value: any) {
            return getUOMValue(value, "t CO2e", selectedUOM);
          },
          style: {
            colors: "#8897AE",
          },
        },
        tickAmount: 5,
        // min: 0,
        // max: 100,
      },
    },
    series: metricsSeries,
  };
  // const [targetMetricsOptions, setTargetMetricsOptions] = useState({
  //   options: metricsOptionsInitMixedChart,
  //   series: initMetricsSeriesMixedChart,
  // });

  const barOptions = {
    options: {
      colors: ["#5394EB", primaryColor, "#F7BA1E"],
      title: {
        text: `x-axis: ${selectedUOM}`,
        style: {
          fontSize: "12px",
          fontFamily: "Roboto",
          color: "#8897AE",
          fontWeight: "100",
        },
      },
      legend: {
        // show:false,
        position: "bottom",
        offsetY: 40,
        horizontalAlign: "right",
      },
      chart: {
        type: "bar",
        height: 350,
        stacked: true,
        toolbar: {
          show: false,
        },

        zoom: {
          enabled: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        x: {
          show: true,
        },
        y: {
          formatter: function (value: any) {
            return getUOMValue(value, "kg CO2e", selectedUOM);
          },
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: true,
          borderRadius: 0,
          columnWidth: "30%",
        },
      },
      xaxis: {
        // type: "string",
        categories: categories2,
        labels: {
          style: {
            colors: "#8897AE",
          },
          formatter: function (value: any) {
            return getUOMValue(value, "kg CO2e", selectedUOM);
          },
        },
      },
      yaxis: {
        min: 0,
        //max: 300,
        tickAmount: 3,
        // labels: {
        //   formatter: function (value: any) {
        //     return value === 0 ? 0 : specialRound(value);
        //   },
        //   style: {
        //     colors: "#8897AE",
        //   },
        // },
        labels: {
          style: {
            colors: "#8897AE",
          },
        },
      },
      fill: {
        opacity: 1,
      },
    },
    series: series2,
  };
  const areaGraphOptions = {
    options: {
      colors: ["#EDBB5E", "#59CE90", "#5496EF"],
      chart: {
        height: 350,
        type: "area",
        toolbar: {
          show: false,
        },
      },
      title: {
        text: `y-axis: ${selectedUOM}`,
        align: "left",
        style: {
          fontSize: "12px",
          fontFamily: "Roboto",
          color: "#8897AE",
          fontWeight: "100",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        colors: undefined,
        width: 1,
        dashArray: 0,
      },
      legend: {
        labels: {
          colors: "#8897AE",
          useSeriesColors: false,
        },
      },
      xaxis: {
        type: "string",
        categories: categories1,
        labels: {
          show: true,
          style: {
            colors: "#8897AE",
            fontSize: "12px",
            fontWeight: 400,
          },
        },
      },
      yaxis: {
        min: 0,
        //max: 300,
        tickAmount: 3,
        labels: {
          formatter: function (value: any) {
            return getUOMValue(value, "kg CO2e", selectedUOM);
          },
          style: {
            colors: "#8897AE",
          },
        },
      },
    },
    series: series1,
  };

  // const [progress1, setProgress1] = useState(0);
  // const [progress2, setProgress2] = useState(0);
  // React.useEffect(() => {
  //   const timer = setInterval(() => {
  //     console.log("in progress")
  //     setProgress1((prevProgress) =>
  //       prevProgress >= (totalEmission.categoryData[0].emissionvalue*100 /totalEmission.total_emission_value) ? prevProgress : prevProgress + 1
  //     );
  //     setProgress2((prevProgress) =>
  //       prevProgress >= (totalEmission.categoryData[1].emissionvalue*100 /totalEmission.total_emission_value) ? prevProgress : prevProgress + 1
  //     );
  //   }, 0.5);
  //   return () => {
  //     clearInterval(timer);
  //   };
  // }, [totalEmission]);
  const [bunitList, setBunitsList] = useState([] as any);
  const [bunitListWithTargets, setBunitsListWithTarget] = useState([] as any);
  const [targetBunit, setTargetBunit] = useState(
    localStorage.getItem("currentBusinessUnit") != null
      ? JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id
      : ""
  );
  const initialMetrics = [
    "Active employees",
    "Gross floor area",
    "Economic intensity",
    "Target no. of units",
  ];
  const [metrics, setMetrics] = useState(initialMetrics);
  const metricsAttributes: any = {
    "Active employees": "ACTIVE_EMPLOYEES",
    "Gross floor area": "GROSS_FLOOR_AREA",
    "Economic intensity": "ECONOMIC_INTENSITY",
    "Target no. of units": "TARGET_NO_OF_UNITS",
  };
  const [selectedBunits, setSelectedBunits] = React.useState<string[]>([]);

  const [category, setCategory] = React.useState<string[]>([]);
  const [categoryList, setCategoryList] = useState([]);

  const monthsArray = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const [isFacilityCheckedAll, setisFacilityCheckedAll] = useState(false);
  const [isCategoryCheckedAll, setisCategoryCheckedAll] = useState(false);
  const [currencies, setCurrencies] = useState<any>([]);
  const [currency, setCurrency] = useState<any>("");
  const [carbonPrice, setCarbonPrice] = useState<any>("");

  const onChangeCurrency = (e: any) => {
    if (e) {
      setCurrency(e);
    }
  };

  // const bunitsStr = localStorage.getItem("bunits");
  const monthFormat = "YYYY/MM";
  const [defaultDateRange, setDefaultRange] = useState<any>([
    dayjs(new Date().getFullYear() + "/01/01", monthFormat),
    dayjs(new Date().getFullYear() + "/12/31", monthFormat),
  ]);
  // const [showDateRange, setShowDateRange] = useState(false);
  const [allocationFacility, setAllocationFacility] = useState(null);
  useEffect(() => {
    getSettingPreferences(true).then((res) => {
      const companyData = res.data.companyPreference;
      if (companyData.allocation_facility) {
        setAllocationFacility(companyData.allocation_facility);
      } else {
        let businessUnits = JSON.parse(
          localStorage.getItem("businessUnits") || "[]"
        );
        let allocationUnit = businessUnits.find(
          (unit: any) => unit.code.substr(-2) == "F1"
        );
        if (allocationUnit) {
          setAllocationFacility(allocationUnit.id);
        }
      }
      if (companyData.is_calendar_year) {
        setDefaultRange([
          dayjs(new Date().getFullYear() + "/01/01", monthFormat),
          dayjs(new Date().getFullYear() + "/12/31", monthFormat),
        ]);
      } else {
        if (companyData.financial_year) {
          const dateRange = companyData.financial_year.split("to");
          let startMonth =
            (dateRange[0].trim().length === 1 ? "0" : "") + dateRange[0].trim();
          let endMonth =
            (dateRange[1].trim().length === 1 ? "0" : "") + dateRange[1].trim();
          setDefaultRange([
            dayjs(
              new Date().getFullYear() + "/" + startMonth + "/01",
              monthFormat
            ),
            dayjs(
              new Date().getFullYear() +
                1 +
                "/" +
                endMonth +
                "/" +
                new Date(
                  new Date().getFullYear() + 1,
                  Number(endMonth) - 1,
                  0
                ).getDate(),
              monthFormat
            ),
          ]);

          setStartMonth(
            new Date(new Date().getFullYear(), Number(startMonth) - 1, 2)
          );
          setEndMonth(
            new Date(
              new Date().getFullYear() + 1,
              Number(endMonth) - 1,
              new Date(
                new Date().getFullYear() + 1,
                Number(endMonth) - 1,
                0
              ).getDate()
            )
          );
        }
      }
      setCurrency(companyData.currency);
      // setShowDateRange(true);
    });
  }, []);

  useEffect(() => {
    getTargetService(targetBunit).then((res) => {
      const targetValues = res.data;
      const baseValues = targetValues.filter(
        (each: any) => each.target_type === TARGET_TYPES.BASELINE
      );
      const allMetrics = baseValues.map((each: any) => each.metrics);
      allMetrics.forEach((metricsArray: any) => {
        const metricType = metricsAttributes[metric] || metric;
        const targetMetric = metricsArray.find(
          (each: any) => each.type === metricType
        );
        const splittedUOM = targetMetric?.uom_name?.split("/");
        if (splittedUOM && splittedUOM.length) {
          const updatedUOMName = `${selectedUOM}/${splittedUOM[1]}`;
          setTargetUomName(updatedUOMName);
        }
      });
    });
  }, [targetBunit, metric, selectedUOM]);

  useEffect(() => {
    if (showList) {
      getTabularData();
    }
    const getCustomMetrics = async () => {
      try {
        setMetrics(initialMetrics);
        const res = await metricsService(targetBunit);
        const typeArray = res.data.map((item: { type: any }) => item.type);
        typeArray.forEach((type: any) => {
          setMetrics((prevMetrics) => {
            if (prevMetrics.includes(type)) {
              return prevMetrics;
            }
            return [...prevMetrics, type];
          });
        });
      } catch (error) {
        console.error("Error fetching metrics data:", error);
      }
    };
    getCustomMetrics();
  }, [targetBunit]);

  useEffect(() => {
    getEmissionCurrencyService()
      .then((res: any) => {
        setCurrencies([...res.data]);
        // setCurrency(CURRENCY.CURRENCY_49);
      })
      .catch((error) => console.log(error));
  }, []);

  // const [category, setCategory] = React.useState<string[]>([]);
  const globalSelectChange = (e: any, type: string) => {
    if (type === "facility") {
      setisFacilityCheckedAll(e.target.checked);
      e.target.checked ? setSelectedBunits(bunitList) : setSelectedBunits([]);
    } else {
      setisCategoryCheckedAll(e.target.checked);
      const tempCategoryList = categoryList.map((each: any) => each?.code);
      e.target.checked ? setCategory(tempCategoryList) : setCategory([]);
    }
  };

  const handleBunitChange = (
    event: SelectChangeEvent<typeof selectedBunits>
  ) => {
    const {
      target: { value },
    } = event;
    setisFacilityCheckedAll(value.length === bunitList.length);
    setSelectedBunits(typeof value === "string" ? value.split(",") : value);
  };
  const onChangeTargetUnit = (e: any) => {
    if (!isNaN(e)) {
      setEmissionsData(null);
      setTargetBunit(e);
    }
  };
  const onChangeMetric = (e: any) => {
    setMetric(e);
  };
  const handleCategoryChange = (event: SelectChangeEvent<typeof category>) => {
    const {
      target: { value },
    } = event;
    setisCategoryCheckedAll(value.length === categoryList.length);
    setCategory(typeof value === "string" ? value.split(",") : value);
  };
  const handleUOMChange = (event: any) => {
    setselectedUOM(event.target.value);
  };
  const [startMonth, setStartMonth] = useState(
    new Date(new Date().getFullYear(), 0, 2)
  );
  const [endMonth, setEndMonth] = useState(
    new Date(new Date().getFullYear(), 11, 31)
  );

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
    const tabLabels: { [key: string]: string } = {
      "1": "Facility",
      "2": "Scope",
      "3": "Category",
    };
    setCurrentTabName(tabLabels[newValue] || "");
    if (newValue === "2") {
      setScopeType("Scope 1");
      setCategoryType(undefined);
    }
    if (newValue === "3") {
      setCategoryType("Category 1.1");
      setScopeType(undefined);
    }
  };

  const scopes = [
    { name: "Scope 1", id: 1 },
    { name: "Scope 2", id: 2 },
    { name: "Scope 3", id: 3 },
  ];

  const onChangeScope = (value: string) => {
    setScopeType(value);
  };

  const onChangeCategory = (value: string) => {
    setCategoryType(value);
  };

  const [dates, setDates] = useState<RangeValue>(null);

  const disabledDate = (current: any) => {
    if (!dates) {
      return false;
    }
    const tooLate = dates[0] && current.diff(dates[0], "year") >= 1;
    const tooEarly = dates[1] && dates[1].diff(current, "year") >= 1;
    return !!tooEarly || !!tooLate;
  };

  const onChangeDate = (e: any) => {
    let startDate = new Date(e[0].$d);
    startDate = new Date(startDate.getFullYear(), startDate.getMonth(), 2);
    setStartMonth(startDate);
    let endDate = new Date(e[1].$d);

    endDate = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 1);
    setEndMonth(endDate);
  };

  const createCategoryToolTip = (
    category: any,
    totalvalue: number,
    selectedUOM: string
  ): any => {
    if (
      category.code == cat41Map[localStorage.getItem("protocol") || "iso"].code
    ) {
      category.value -= allocationTotal * 1000;
    }
    return (
      `<div style="padding:10px;text-align: start;background-color:#FAFBFD;display:flex;flex-direction:column;font-family:'Roboto';">` +
      '<div style="display:flex;flex-direction:row;gap:20px"><span style="font-weight:700;display:flex;flex:1">' +
      category.code +
      `</span> <span style="display:flex;flex:2">` +
      category.name +
      "</span></div>" +
      '<div  style="display:flex;flex-direction:row;gap:10px"> <span style="font-weight:600;">' +
      getUOMValue(category.value, "kg CO2e", selectedUOM) +
      ` ${selectedUOM} </span> <span style='color:#8897AE'>(` +
      (category.value / totalvalue < 0.01
        ? " < 1"
        : specialRound((category.value / totalvalue) * 100)) +
      "%) </span> </div>" +
      "</div>" +
      (category.code ==
        cat41Map[localStorage.getItem("protocol") || "iso"].code &&
      allocationTotal > 0
        ? '<div style="display:flex;flex-direction:row;gap:20px;width:fit-content;text-align:start;padding:10px"><span style="font-weight:700;display:flex;flex:1">' +
          cat41Map[localStorage.getItem("protocol") || "iso"].code +
          `</span> <span style="display:flex;flex:2">` +
          "Purchase of Goods & Services - allocated" +
          "</span></div>" +
          '<div  style="display:flex;flex-direction:row;gap:10px;text-align:start;padding:10px"> <span style="font-weight:600;">' +
          getUOMValue(allocationTotal * 1000, "kg CO2e", selectedUOM) +
          ` ${selectedUOM} </span> <span style='color:#8897AE'>(` +
          ((allocationTotal * 1000) / totalvalue < 0.01
            ? " < 1"
            : specialRound(((allocationTotal * 1000) / totalvalue) * 100)) +
          "%) </span> </div>"
        : "")
    );
  };

  let [allocationTotal, setAllocationTotal] = useState(0);
  let [
    allocationEmissionsMonthlyBreakup,
    setAllocationEmissionsMonthlyBreakup,
  ] = useState<any>(null);
  let [allocationArray, setAllocationArray] = useState<any>([]);

  let [cat5AllocationTotal, setCat5AllocationTotal] = useState(0);
  let [
    cat5AllocationEmissionsMonthlyBreakup,
    setCat5AllocationEmissionsMonthlyBreakup,
  ] = useState<any>(null);
  let [cat5AllocationArray, setCat5AllocationArray] = useState<any>([]);

  const getAllocatedEmissions = () => {
    // let [comp]
    if (
      (selectedBunits.length == 0 ||
        selectedBunits.filter((unit: any) => unit.id == allocationFacility)
          .length) &&
      (category.length == 0 ||
        category.includes(
          cat41Map[localStorage.getItem("protocol") || "iso"].code
        ))
    ) {
      getSupplierAllocatedEmissions(
        startMonth.toISOString(),
        endMonth.toISOString()
      ).then((res) => {
        console.log(res.data);
        setAllocationTotal(res.data.totalAllocatedEmissions);
        let allocationMap: any = {};
        res.data.periodic_breakup.forEach((period: any) => {
          allocationMap[period.month] = period.allocated_total_emissions * 1000;
        });
        setAllocationEmissionsMonthlyBreakup(allocationMap);
        allocationArray = [];
        for (const key in allocationMap) {
          allocationArray.push({
            name: key.split("-").join(" - "),
            value: allocationMap[key],
          });
        }
        setAllocationArray([...allocationArray]);
      });
      getSupplierAllocatedEmissions(
        startMonth.toISOString(),
        endMonth.toISOString(),
        true
      ).then((res) => {
        console.log(res.data);
        if (res?.data?.totalAllocatedEmissions) {
          setCat5AllocationTotal(res.data.totalAllocatedEmissions);
          let allocationMap: any = {};
          res.data.periodic_breakup.forEach((period: any) => {
            if (!allocationMap[period.name]) {
              allocationMap[period.name] = {};
            }
            allocationMap[period.name][period.month] =
              period.allocated_total_emissions * 1000;
          });
          setCat5AllocationEmissionsMonthlyBreakup(allocationMap);
          cat5AllocationArray = [];
          for (const entryKey of Object.keys(allocationMap)) {
            allocationArray = [];
            for (const key in allocationMap[entryKey]) {
              allocationArray.push({
                name: key.split("-").join(" - "),
                value: allocationMap[entryKey][key],
                category: entryKey,
              });
            }
            cat5AllocationArray.push(allocationArray);
          }
          setCat5AllocationArray(
            JSON.parse(JSON.stringify(cat5AllocationArray))
          );
        }
      });
    } else {
      setAllocationArray([]);
      setAllocationTotal(0);
      setAllocationEmissionsMonthlyBreakup(null);
      setCat5AllocationArray([]);
      setCat5AllocationTotal(0);
      setCat5AllocationEmissionsMonthlyBreakup(null);
    }
  };

  const onOpenChange = (open: boolean) => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };

  useEffect(() => {
    fetchBusinessUnits({}).then((res) => {
      const data = res.data;
      const bunitsList: [] = data.businessUnits;
      bunitsList.sort((a: any, b: any) => a.name.localeCompare(b.name));
      setBunitsList(bunitsList);
    });
  }, []);

  useEffect(() => {
    const reqObj = {
      emissionTarget: true,
      hasTarget: true,
    };
    fetchBusinessUnits(reqObj).then((res) => {
      const data = res.data;
      const bunitsList: any[] = data.businessUnits;
      if (
        bunitsList?.length &&
        !bunitsList
          ?.map((eachUnit: any) => eachUnit.id)
          ?.includes(
            parseInt(
              JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id
            )
          )
      ) {
        setTargetBunit(bunitsList[0].id);
      }
      setBunitsListWithTarget([...bunitsList]);
    });
  }, []);

  useEffect(() => {
    let company =
      localStorage.getItem("company") &&
      JSON.parse(localStorage.getItem("company") || "").id;
    emissionAvailableCategoriesService(company, true)
      .then((res) => {
        let catList: [] = res.data;

        catList.sort((a: any, b: any) => a.code.localeCompare(b.code));
        setCategoryList([...catList]);
      })
      .catch((err) => {
        console.log("Error:", err?.response?.data?.message);
      });
  }, []);

  useEffect(() => {
    if (currency) {
      getAllocatedEmissions();
      const bunitsIdsList: any[] = selectedBunits.map((each: any) => each.id);
      //console.log("selected b unit => ", bunitsIdsList);
      const bunitsString: string = bunitsIdsList.toString();
      // const categoriesString: string = category.toString();
      //console.log("selected categoryString -> ", categoriesString);
      const categoryArray = category.map((eachCategory) =>
        categoryList.filter((each: any) => eachCategory === each.code)
      );
      const categoriesString = categoryArray
        .map((each: any) => each[0]?.id)
        .toString();
      let emissionObj: any = {};
      if (bunitsIdsList.length) {
        emissionObj.businessUnitIds = bunitsString;
      } else {
        emissionObj.businessUnitIds =
          bunitList.length > 0
            ? bunitList.map((eachUnit: any) => eachUnit.id).join(",")
            : "";
      }
      if (!emissionObj.businessUnitIds?.length) {
        setCarbonPrice(0);
        return;
      }
      emissionObj.from_date = startMonth;
      emissionObj.to_date = endMonth;
      emissionObj.categories = categoriesString;
      getCarbonPriceService({ ...emissionObj, currency })
        .then((res) => {
          let data = res.data;
          console.log("data", data);
          setCarbonPrice(res.data.totalCarbonPrice);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [selectedBunits, bunitList, category, startMonth, endMonth, currency]);
  const invCatMap: any = {
    "Listed equity and corporate bonds": "Category 5.4A",
    "Business loans and unlisted equity": "Category 5.4B",
    "Project finance": "Category 5.4C",
    "Commercial real estate": "Category 5.4D",
    Mortgages: "Category 5.4E",
    "Motor vehicle loans": "Category 5.4 F",
    "Sovereign debt": "Category 5.4E",
  };

  const invIdMap: any = {
    "Category 5.4A": 46,
    "Category 5.4B": 47,
    "Category 5.4C": 48,
    "Category 5.4D": 49,
    "Category 5.4E": 50,
    "Category 5.4F": 51,
    "Category 5.4G": 52,
  };
  useEffect(() => {
    const bunitsIdsList: any[] = selectedBunits.map((each: any) => each.id);
    const bunitsString: string = bunitsIdsList.toString();
    // const categoriesString: string = category.toString();
    const categoryArray = category.map((eachCategory) =>
      categoryList.filter((each: any) => eachCategory === each.code)
    );
    const categoriesString = categoryArray
      .map((each: any) => each[0]?.id)
      .toString();
    let emissionObj: any = {};
    if (bunitsIdsList.length) {
      emissionObj.businessUnitIds = bunitsString;
    } else {
      emissionObj.businessUnitIds =
        bunitList.length > 0
          ? bunitList.map((eachUnit: any) => eachUnit.id).join(",")
          : "";
    }
    if (!emissionObj.businessUnitIds?.length) {
      setIsLoading(false);
      return;
    }
    emissionObj.from_date = startMonth;
    emissionObj.to_date = endMonth;
    emissionObj.categories = categoriesString;
    emissionsByUnitService(emissionObj)
      .then((res) => {
        let data = res.data;
        let facilityIndex = data.findIndex(
          (bu: any) => bu.id == allocationFacility
        );
        if (facilityIndex > -1) {
          data[facilityIndex].value += allocationTotal * 1000;
          data[facilityIndex].value += cat5AllocationTotal * 1000;
        } else {
          let allocationUnit = bunitList.find(
            (unit: any) => unit.id == allocationFacility
          );
          if (allocationUnit) {
            data.push({
              id: allocationUnit.id,
              name: allocationUnit.name,
              value: (allocationTotal + cat5AllocationTotal) * 1000,
            });
          }
        }
        let values = data.map((eachData: any) => round(eachData.value));
        let labels = data.map((eachData: any) => eachData.name);
        setSeries4(values);
        setCategories4(labels);
        // horizontalBarOptions.series[0].data = values;
        // horizontalBarOptions.options.xaxis.categories = labels;
        // setSeries2(values);
        // setCategories2(labels);

        //setHorizontalBarOptions({...horizontalBarOptions});
      })
      .catch((err) => {
        console.log(err);
      });

    getEmissionValueTotalService(emissionObj)
      .then((res) => {
        let data = res.data;
        let totalvalue =
          data.total_emission_value +
          (allocationTotal + cat5AllocationTotal) * 1000;
        if (allocationTotal) {
          let isCat41Exists =
            data.categoryData.filter(
              (eachCategory: any) =>
                eachCategory.category ===
                cat41Map[localStorage.getItem("protocol") || "iso"].code
            ).length == 1;
          if (isCat41Exists) {
            let cat41index = data.categoryData.findIndex(
              (eachCategory: any) =>
                eachCategory.category ===
                cat41Map[localStorage.getItem("protocol") || "iso"].code
            );
            data.categoryData[cat41index].emissionvalue +=
              allocationTotal * 1000;
          } else {
            data.categoryData.push({
              category:
                cat41Map[localStorage.getItem("protocol") || "iso"].code,
              emissionvalue: allocationTotal * 1000,
              name: "Purchase Goods & Services",
              scope: "Other indirect emissions",
              scope_code: "Scope 3",
            });
          }
        }

        if (cat5AllocationTotal) {
          for (const allocArray of cat5AllocationArray) {
            let isCatExists =
              data.categoryData.filter(
                (eachCategory: any) =>
                  eachCategory.category === invCatMap[allocArray[0].category]
              ).length == 1;
            if (isCatExists) {
              let catIndex = data.categoryData.findIndex(
                (eachCategory: any) =>
                  eachCategory.category === invCatMap[allocArray[0].category]
              );
              data.categoryData[catIndex].emissionvalue += allocArray
                .map((each: any) => each.value)
                .reduce((acc: any, eachItem: any) => eachItem + acc, 0);
            } else {
              data.categoryData.push({
                category: invCatMap[allocArray[0].category],
                emissionvalue: allocArray
                  .map((each: any) => each.value)
                  .reduce((acc: any, eachItem: any) => eachItem + acc, 0),
                name: allocArray[0].category,
                scope: "Other indirect emissions",
                scope_code: "Scope 3",
              });
            }
          }
        }
        let emissionData = data.categoryData.map((each: any) => {
          return {
            ...each,
            emissionvalue: String(each.emissionvalue),
            progress:
              data.total_emission_value +
              ((allocationTotal + cat5AllocationTotal) * 1000 || 0)
                ? (
                    (each?.emissionvalue * 100) /
                    (data.total_emission_value +
                      ((allocationTotal + cat5AllocationTotal) * 1000 || 0))
                  )
                    .toFixed(1)
                    .toString()
                : "0",
          };
        });
        setTopThreeEmissions(data.categoryData ? emissionData : []);
        setTotalEmission({
          total_emission_value: totalvalue,
          uom: data.uom,
          conversion_value: data.conversion_value,
          categories: [
            {
              name: data.categoryData[0]?.name,
              category: data.categoryData[0]?.category,
              value:
                specialRound(data.categoryData[0]?.emissionvalue) + " Kg CO2e",
              progress: totalvalue
                ? (
                    (data.categoryData[0]?.emissionvalue * 100) /
                    totalvalue
                  ).toFixed(0)
                : "0",
            },
            {
              name: data.categoryData[1]?.name,
              category: data.categoryData[1]?.category,
              value:
                specialRound(data.categoryData[1]?.emissionvalue) + " Kg CO2e",
              progress: totalvalue
                ? ((data.categoryData[1]?.emissionvalue * 100) / totalvalue)
                    .toFixed(0)
                    .toString()
                : "0",
            },
          ],
        });
        getAllEmissionsService(emissionObj).then((res) => {
          let data = res.data;
          if (allocationTotal) {
            let scope3Index = data.findIndex(
              (item: any) => item.code === "Scope 3"
            );
            if (scope3Index > -1) {
              let cat4index = data[scope3Index].categories.findIndex(
                (item: any) => item.code == "Category 4"
              );
              if (cat4index > -1) {
                let cat41index = data[scope3Index].categories[
                  cat4index
                ].subcategories.findIndex(
                  (item: any) =>
                    item.code ==
                    cat41Map[localStorage.getItem("protocol") || "iso"].code
                );
                data[scope3Index].categories[cat4index].subcategories[
                  cat41index
                ].value += allocationTotal * 1000;
                data[scope3Index].categories[cat4index].subcategories[
                  cat41index
                ].name = "Purchase Goods & Services - Primary";
                data[scope3Index].categories[cat4index].value +=
                  allocationTotal * 1000;
                data[scope3Index].value += allocationTotal * 1000;
              }
            }
          }
          let sankeyData: any = [
            [
              "From",
              "To",
              "Weight",
              { type: "string", role: "tooltip", p: { html: true } },
              { type: "string", role: "style" },
            ],
          ];
          data.map((eachScope: any) => {
            eachScope.categories.map((eachCategory: any) => {
              sankeyData.push([
                eachScope.code,
                eachCategory.code,
                eachCategory.value / totalvalue < 0.01
                  ? totalvalue / 100
                  : eachCategory.value,
                createCategoryToolTip(eachCategory, totalvalue, selectedUOM),
                `${scopeColors[eachScope.code]}`,
              ]);
              eachCategory?.subcategories?.map((eachSubCategory: any) => {
                sankeyData.push([
                  eachCategory.code,
                  eachSubCategory.code,
                  eachSubCategory.value / totalvalue < 0.01
                    ? totalvalue / 100
                    : eachSubCategory.value,
                  createCategoryToolTip(
                    eachSubCategory,
                    totalvalue,
                    selectedUOM
                  ),
                  `${scopeColors[eachScope.code]}`,
                ]);
              });
            });
          });
          setData3(sankeyData);
          setIsLoading(false);
        });
      })
      .catch(() => {
        setTopThreeEmissions([]);
        setData3([]);
      });

    getEmissionByScopeAndMonthService(emissionObj).then((res) => {
      let data = res.data;
      let catMap: any = {};
      if (allocationTotal) {
        if (!data.data.filter((scope: any) => scope.name == "Scope 3").length) {
          data.data.push({
            id: 3,
            scope: 3,
            name: "Scope 3",
            data: [],
          });
        }
        let scope3Index = data.data.findIndex(
          (scope: any) => scope.name == "Scope 3"
        );
        allocationArray.forEach((allocation: any) => {
          let dataIndex = data.data[scope3Index].data.findIndex(
            (record: any) => record.name == allocation.name
          );
          if (dataIndex >= 0) {
            data.data[scope3Index].data[dataIndex].value += allocation.value;
          } else {
            data.data[scope3Index].data.push(allocation);
          }
          let xdataIndex = data.xaxis.findIndex(
            (record: any) => record.months == allocation.name
          );
          if (xdataIndex == -1) {
            // let xdataIndex  = data.xaxis.findIndex((record:any)=>record.months==allocation.name);
            data.xaxis.push({
              from_month: monthsArray.findIndex(
                (month: string) => month == allocation.name.split(" ")[0]
              ),
              month: allocation.name.split(" ")[0],
              months: allocation.name,
              year: allocation.name.split(" ")[4],
            });
          }
        });
      }
      if (cat5AllocationTotal) {
        if (!data.data.filter((scope: any) => scope.name == "Scope 3").length) {
          data.data.push({
            id: 3,
            scope: 3,
            name: "Scope 3",
            data: [],
          });
        }
        let scope3Index = data.data.findIndex(
          (scope: any) => scope.name == "Scope 3"
        );
        cat5AllocationArray.forEach((catAllocations: any) => {
          catAllocations.forEach((allocation: any) => {
            let dataIndex = data.data[scope3Index].data.findIndex(
              (record: any) => record.name == allocation.name
            );
            if (dataIndex >= 0) {
              data.data[scope3Index].data[dataIndex].value += allocation.value;
            } else {
              data.data[scope3Index].data.push(allocation);
            }
            let xdataIndex = data.xaxis.findIndex(
              (record: any) => record.months == allocation.name
            );
            if (xdataIndex == -1) {
              // let xdataIndex  = data.xaxis.findIndex((record:any)=>record.months==allocation.name);
              data.xaxis.push({
                from_month: monthsArray.findIndex(
                  (month: string) => month == allocation.name.split(" ")[0]
                ),
                month: allocation.name.split(" ")[0],
                months: allocation.name,
                year: allocation.name.split(" ")[4],
              });
            }
          });
        });
      }

      let cat1 = data.xaxis.map((each: any) => {
        catMap[each.months] = 0;
        return each.months;
      });
      let finalData = data.data.map((eachData: any) => {
        let eachCatMap = deepClone(catMap);
        eachData.data.map((eachValue: any) => {
          eachCatMap[eachValue.name] = round(eachValue.value);
        });
        eachData.data = Object.values(eachCatMap);
        return eachData;
      });
      setSeries1(finalData);
      setCategories1(cat1);
    });

    emissionsByMonthService(emissionObj).then((res) => {
      let data = res.data;
      setEmissionByMonth(data);
      let years = yearsMap;
      data?.t1?.forEach((eachScope: any) => {
        if (localStorage.getItem("protocol") == "ghg") {
          eachScope.id = 69 + eachScope.id;
        }
        for (let monthYear in eachScope.data) {
          const year = monthYear.split("-")[1];
          if (!years.year) {
            years[year] = true;
          }
        }
      });
      if (allocationTotal) {
        let scope3Index = data?.t1.findIndex(
          (scope: any) => scope.code == "Scope 3"
        );
        if (scope3Index == -1) {
          data?.t1.push({
            code: "Scope 3",
            data: allocationEmissionsMonthlyBreakup,
            id: 3,
            name: "Other indirect emissions",
            total_value: allocationTotal * 1000,
            type_name: "MainCategory1",
          });
        } else {
          for (let key in allocationEmissionsMonthlyBreakup) {
            if (data.t1[scope3Index].data[key] != undefined) {
              data.t1[scope3Index].data[key] +=
                allocationEmissionsMonthlyBreakup[key];
            } else {
              data.t1[scope3Index].data[key] =
                allocationEmissionsMonthlyBreakup[key];
            }
          }
          data.t1[scope3Index].total_value += allocationTotal * 1000;
        }
        let cat4Index = data?.t2.findIndex(
          (cat: any) => cat.code == "Category 4"
        );
        if (cat4Index == -1) {
          data?.t2.push({
            code: "Category 4",
            data: allocationEmissionsMonthlyBreakup,
            id: 7,
            name: "Indirect GHG emission from products used by organisation",
            parent: 3,
            total_value: allocationTotal * 1000,
            type_name: "SubCategory1",
          });
        } else {
          for (let key in allocationEmissionsMonthlyBreakup) {
            if (data.t2[cat4Index].data[key] != undefined) {
              data.t2[cat4Index].data[key] +=
                allocationEmissionsMonthlyBreakup[key];
            } else {
              data.t2[cat4Index].data[key] =
                allocationEmissionsMonthlyBreakup[key];
            }
          }
          data.t2[cat4Index].total_value += allocationTotal * 1000;
        }
        let isCat41Exists =
          data?.t3.filter(
            (cat: any) =>
              cat.code ==
              cat41Map[localStorage.getItem("protocol") || "iso"].code
          ).length == 1;
        let insertIndex = 0;
        if (isCat41Exists) {
          insertIndex =
            data?.t3.findIndex(
              (cat: any) =>
                cat.code ==
                cat41Map[localStorage.getItem("protocol") || "iso"].code
            ) + 1;
          data.t3[insertIndex - 1].name = "Purchase Goods & Services - Primary";
        }
        data.t3.splice(insertIndex, 0, {
          code: cat41Map[localStorage.getItem("protocol") || "iso"].code,
          data: allocationEmissionsMonthlyBreakup,
          id: 23,
          name: "Purchase Goods & Services - Allocated",
          parent: 7,
          total_value: allocationTotal * 1000,
          type_name: "SubCategory2",
        });
      }
      if (cat5AllocationTotal) {
        let scope3Index = data?.t1.findIndex(
          (scope: any) => scope.code == "Scope 3"
        );
        let scope3Data: any = {};
        for (const key in cat5AllocationEmissionsMonthlyBreakup) {
          for (const eachKey in cat5AllocationEmissionsMonthlyBreakup[key]) {
            if (scope3Data[eachKey]) {
              scope3Data[eachKey] +=
                cat5AllocationEmissionsMonthlyBreakup[key][eachKey] * 1000;
            } else {
              scope3Data[eachKey] =
                cat5AllocationEmissionsMonthlyBreakup[key][eachKey] * 1000;
            }
          }
        }
        if (scope3Index == -1) {
          data?.t1.push({
            code: "Scope 3",
            data: scope3Data,
            id: 3,
            name: "Other indirect emissions",
            total_value: cat5AllocationTotal * 1000,
            type_name: "MainCategory1",
          });
        } else {
          for (let key in scope3Data) {
            if (data.t1[scope3Index].data[key] != undefined) {
              data.t1[scope3Index].data[key] += scope3Data[key];
            } else {
              data.t1[scope3Index].data[key] = scope3Data[key];
            }
          }
          data.t1[scope3Index].total_value += cat5AllocationTotal * 1000;
        }
        let cat5Index = data?.t2.findIndex(
          (cat: any) => cat.code == "Category 5"
        );
        if (cat5Index == -1) {
          data?.t2.push({
            code: "Category 5",
            data: scope3Data,
            id: 8,
            name: "Indirect GHG emissions associated with the use of products from the organisation",
            parent: 3,
            total_value: cat5AllocationTotal * 1000,
            type_name: "SubCategory1",
          });
        } else {
          for (let key in scope3Data) {
            if (data.t2[cat5Index].data[key] != undefined) {
              data.t2[cat5Index].data[key] += scope3Data[key];
            } else {
              data.t2[cat5Index].data[key] = scope3Data[key];
            }
          }
          data.t2[cat5Index].total_value += cat5AllocationTotal * 1000;
        }

        for (const key in cat5AllocationEmissionsMonthlyBreakup) {
          let isCatExists =
            data?.t3.filter((cat: any) => cat.code == invCatMap[key]).length ==
            1;
          let insertIndex = 0;
          if (isCatExists) {
            insertIndex =
              data?.t3.findIndex((cat: any) => cat.code == invCatMap[key]) + 1;
            data.t3[insertIndex - 1].name = key + " - Primary";
          }
          let total = 0;

          for (const item in cat5AllocationEmissionsMonthlyBreakup[key]) {
            total += cat5AllocationEmissionsMonthlyBreakup[key][item];
          }
          data.t3.splice(insertIndex, 0, {
            code: invCatMap[key],
            data: cat5AllocationEmissionsMonthlyBreakup[key],
            id: invIdMap[invCatMap[key]],
            name: key + " - Allocated",
            parent: 8,
            total_value: total,
            type_name: "SubCategory2",
          });
        }
      }
      setYearsMap(years);
    });

    let offsetObj = {
      businessUnits: emissionObj.businessUnitIds,
      fromMonth: startMonth.toISOString().slice(0, 7),
      toMonth: endMonth.toISOString().slice(0, 7),
    };
    getOffsetsByMonth(offsetObj)
      .then((res: any) => {
        setTotalOffsetValue({
          totalValue: res?.data?.total_value || 0,
          tco2e: res?.data?.tco2e || 0,
          mwh: res?.data?.mwh || 0,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [
    selectedBunits,
    bunitList,
    category,
    startMonth,
    endMonth,
    selectedUOM,
    allocationTotal,
  ]);

  useEffect(() => {
    const bunitsIdsList: any[] = selectedBunits.map((each: any) => each.id);
    //console.log("selected b unit => ", bunitsIdsList);
    const bunitsString: string = bunitsIdsList.toString();
    const categoryArray = category.map((eachCategory) =>
      categoryList.filter((each: any) => eachCategory === each.code)
    );
    // console.log("cat array -> ", categoryArray);
    const categoriesString = categoryArray
      .map((each: any) => each[0]?.id)
      .toString();
    let emissionObj: any = {};
    if (bunitsIdsList.length) {
      emissionObj.businessUnitIds = bunitsString;
    } else {
      emissionObj.businessUnitIds =
        bunitList.length > 0
          ? bunitList.map((eachUnit: any) => eachUnit.id).join(",")
          : "";
    }
    if (!emissionObj.businessUnitIds?.length) {
      return;
    }
    emissionObj.from_date = startMonth;
    emissionObj.to_date = endMonth;
    emissionObj.categories = categoriesString;
    if (parseInt(scope.toString()) !== 4) {
      emissionObj.scopes = scope;
    }
    // emissionObj.scopes = scope;
    getEmissionsByScopeandCategoriesService(emissionObj).then((res) => {
      let data = res.data;
      // Adding Cat 4.1 allocation emissions to the graph data
      if (
        allocationTotal &&
        (emissionObj.scopes == 3 || emissionObj.scopes == undefined)
      ) {
        let cat41Index = res.data.data.findIndex(
          (cat: any) =>
            cat.name == cat41Map[localStorage.getItem("protocol") || "iso"].code
        );
        if (cat41Index == -1) {
          res.data.data.push({
            category: cat41Map[localStorage.getItem("protocol") || "iso"].id,
            data: [],
            id: cat41Map[localStorage.getItem("protocol") || "iso"].id,
            name: cat41Map[localStorage.getItem("protocol") || "iso"].code,
          });
          cat41Index = res.data.data.length - 1;
        }
        allocationArray.forEach((allocation: any) => {
          let monthIndex = res.data.data[cat41Index].data.findIndex(
            (record: any) => record.name == allocation.name
          );
          if (monthIndex > -1) {
            res.data.data[cat41Index].data[monthIndex].value +=
              allocation.value;
          } else {
            res.data.data[cat41Index].data.push(allocation);
          }
          let xdataIndex = data.xaxis.findIndex(
            (record: any) => record.months == allocation.name
          );
          if (xdataIndex == -1) {
            data.xaxis.push({
              from_month: monthsArray.findIndex(
                (month: string) => month == allocation.name.split(" ")[0]
              ),
              month: allocation.name.split(" ")[0],
              months: allocation.name,
              year: allocation.name.split(" ")[4],
            });
          }
        });
      }
      let catMap: any = {};
      let cat1 = data.xaxis.map((each: any) => {
        catMap[each.months] = 0;
        return each.months;
      });
      let finalData = data.data
        .sort((a: any, b: any) => {
          return a.category - b.category;
        })
        .map((eachData: any) => {
          let eachCatMap = deepClone(catMap);
          eachData.data.map((eachValue: any) => {
            eachCatMap[eachValue.name] = round(eachValue?.value);
          });
          eachData.data = Object.values(eachCatMap);
          return eachData;
        });
      console.log("finalData 2", finalData);

      setSeries2(finalData);

      setCategories2(cat1);
    });
  }, [
    selectedBunits,
    bunitList,
    category,
    startMonth,
    endMonth,
    scope,
    allocationTotal,
  ]);

  useEffect(() => {
    const emissionsByYear = emissionsByYearService(
      targetBunit,
      scopeType ?? "",
      categoryType ?? ""
    );
    const offsetsByYear = getOffsetsByYear({ businessUnits: targetBunit });
    Promise.all([emissionsByYear, offsetsByYear])
      .then((res) => {
        let targetEmissionsYear: any[] = [];
        let metricEmissionsYear: any[] = [];
        // let targOptions = targetOptions;
        let targOptionsSeries: any = [
          {
            name: "Target",
            type: "line",
            data: [],
          },
          {
            name: "Net  Emissions",
            type: "column",
            data: [],
          },
        ];
        let metricsOptionsSeries: any = [
          {
            name: "Metric",
            type: "line",
            data: [],
          },
          {
            name: "Net Emissions",
            type: "column",
            data: [],
          },
        ];
        // let metricOptions = targetMetricsOptions;
        let emissionsTarMap: any = {};
        let emissionsMetMap: any = {};
        let tarMap: any = {};
        let offsetMap: any = {};
        let metrisMap: any = {};
        res[0].data.forEach((each: any) => {
          targetEmissionsYear.push(each.year);
          metricEmissionsYear.push(each.year);
          emissionsTarMap[each.year] = each.value;
          emissionsMetMap[each.year] = each.value;
        });
        res[1].data.forEach((each: any) => {
          offsetMap[each.year] = each.value;
          if (emissionsTarMap[each.year]) {
            emissionsTarMap[each.year] -= each.value;
            emissionsMetMap[each.year] -= each.value;
          } else {
            targetEmissionsYear.push(each.year);
            metricEmissionsYear.push(each.year);
            emissionsTarMap[each.year] = 0 - each.value;
            emissionsMetMap[each.year] = 0 - each.value;
          }
        });
        targetsByYearService(
          targetBunit,
          currentTabName,
          scopeType ?? "",
          categoryType ?? ""
        ).then((targetRes) => {
          targetRes.data.forEach((each: any) => {
            if (targetRes.data.length === 1 && each.type === "MOST RECENT") {
              targetsByYearData = [];
            } else {
              tarMap[each.year] = each.value;
              targetsByYearData = targetRes.data;
              if (targetEmissionsYear.indexOf(each.year) < 0) {
                targetEmissionsYear.push(each.year);
              }
            }
          });
          targetEmissionsYear.sort();
          // targOptions.options.xaxis.categories = targetEmissionsYear;
          targetEmissionsYear.forEach((eachYear) => {
            targOptionsSeries[0].data.push(
              tarMap[eachYear] || tarMap[eachYear] === 0
                ? tarMap[eachYear]
                : undefined
            );
            targOptionsSeries[1].data.push(
              emissionsTarMap[eachYear] ? emissionsTarMap[eachYear] : 0
            );
          });
          targOptionsSeries[0]?.data &&
            extrapolateArray(targOptionsSeries[0].data, targetEmissionsYear);
          setTargetCategories(targetEmissionsYear);
          setTargetSeries(targOptionsSeries);
        });

        metricsByYearService(
          targetBunit,
          metricsAttributes[metric] || metric,
          currentTabName,
          scopeType ?? "",
          categoryType ?? ""
        ).then((res) => {
          let baselineValue =
            res.data.find(
              (each: any) => each?.target_type === TARGET_TYPES.BASELINE
            )?.count || 1;
          Object.entries(emissionsMetMap).map(
            ([key, value], id: any) =>
              (emissionsMetMap[key] = emissionsMetMap[key] / baselineValue)
          );
          res.data.forEach((each: any) => {
            metrisMap[each.year] = each.value;
            if (metricEmissionsYear.indexOf(each.year) < 0) {
              metricEmissionsYear.push(each.year);
            }
          });
          metricEmissionsYear.sort();
          // metricOptions.options.xaxis.categories = metricEmissionsYear;
          metricEmissionsYear.forEach((eachYear, index) => {
            metricsOptionsSeries[0].data.push(
              metrisMap[eachYear] || metrisMap[eachYear] === 0
                ? metrisMap[eachYear]
                : undefined
            );
            metricsOptionsSeries[1].data.push(
              emissionsMetMap[eachYear] ? emissionsMetMap[eachYear] : 0
            );
          });
          metricsOptionsSeries[0]?.data &&
            extrapolateArray(metricsOptionsSeries[0].data, metricEmissionsYear);
          setMetricsCategories(metricEmissionsYear);
          setMetricsSeries(metricsOptionsSeries);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [targetBunit, metric, currentTab, scopeType, categoryType]);

  const renderEmissionValue = (obj: any) => {
    const floatValue = parseFloat(obj?.emissionvalue);
    const [formattedValue, unit] = graphRoundOff(floatValue / 1000);
    const returnvalue =
      floatValue > 1000
        ? formattedValue.toFixed(2) + `${unit} t CO2e`
        : floatValue === 0
        ? "--"
        : floatValue.toFixed(2) + " kg CO2e";
    return returnvalue;
  };
  const isIdSelected = (
    parameter: string,
    value: any,
    selectedValueList: any
  ) => {
    let isSelected = false;
    selectedValueList.map((each: any) => {
      if (
        (parameter === "code" && each === value) ||
        each[parameter] === value
      ) {
        isSelected = true;
      }
    });
    return isSelected;
  };
  const TotalEmissionValue = graphRoundOff(
    totalEmission.total_emission_value / 1000
  );
  const CarbonPriceValue = graphRoundOff(carbonPrice);
  const ConversionValue = graphRoundOff(totalEmission.conversion_value);
  return (
    <div className="overflow-y-auto">
      <div className=" pw-dashboard-main-div flex flex-row items-center justify-end pw-dashboard-filters">
        {/* <div className="pw-content flex flex-row gap-5 pw-border-bottom pb-2">
          <p className="text-sm text-neutral-900">{t("Overview")}</p>
          <p className="text-sm text-neutral-900">{t("Emissions")}</p>
          <p className="text-sm text-neutral-900">{t("Offsets")}</p>
          <p className="text-sm text-neutral-900">{t("More")}</p>
        </div> */}
        <div className="pw-buttons flex flex-row gap-3 items-center">
          {/* <div className=" pw-header-button gap-2 flex flex-row items-center justify-center bg-white text-sm font-bold">
            <ShareOutlinedIcon /> 
            Share
          </div>
          <div className="pw-header-button gap-2 flex flex-row items-center justify-center bg-white text-sm font-bold">
            <LocalPrintshopOutlinedIcon />
            Print
          </div>
          <div className=" pw-header-button gap-2 flex flex-row items-center justify-center bg-white text-sm font-bold">
            <DownloadIcon />
            Export
          </div> */}
          {/* <Box sx={{ background: "white", borderRadius: "8px" }}>
            <FormControl fullWidth size="small">
              <InputLabel className="!text-neutral-900">
                kgCO2e
              </InputLabel>
              <Select
                value={selectedBunits}
                multiple
                label="kgCO2e"
                className="pw-selectbunit"
                onChange={handleBunitChange}
                renderValue={(p) =>
                  p.length > 0 ? p.length + " " + "Business selected" : ""
                }
                input={<InputStyle />}
              >
                <MenuItem>
                    {"tCO2e"}
                  </MenuItem>
              </Select>
            </FormControl>
          </Box> */}
          <Select
            className="pw-dashboard-uom bg-white"
            input={<InputStyle />}
            onChange={handleUOMChange}
            value={selectedUOM}
          >
            <MenuItem value={"t CO2e"}>t CO2e</MenuItem>
            <MenuItem value={"kg CO2e"}>kg CO2e</MenuItem>
          </Select>
          <Box sx={{ background: "white", borderRadius: "8px" }}>
            <FormControl fullWidth size="small">
              <InputLabel
                id="demo-simple-select-label"
                className="!text-neutral-900"
              >
                {t("Facility")}
              </InputLabel>
              <Select
                value={selectedBunits}
                multiple
                label={t("Facility")}
                className="pw-selectbunit"
                onChange={handleBunitChange}
                renderValue={(p) =>
                  p.length > 0
                    ? (p.length === bunitList.length ? "All" : p.length) +
                      " " +
                      t("Facility selected")
                    : ""
                }
                input={<InputStyle />}
              >
                <MenuItem>
                  <Checkbox
                    checked={isFacilityCheckedAll}
                    onChange={(e: any) => globalSelectChange(e, "facility")}
                  />
                  All Units
                </MenuItem>
                {bunitList.map((each: any) => (
                  <MenuItem value={each} key={each.id}>
                    <Checkbox
                      className="pw-emission-check"
                      checked={isIdSelected("id", each.id, selectedBunits)}
                    />
                    {each.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ background: "white", borderRadius: "8px" }}>
            <FormControl fullWidth size="small">
              <InputLabel className="!text-neutral-900">
                {t("Category")}
              </InputLabel>
              <Select
                label={t("Category")}
                value={category}
                className="pw-selectbunit"
                multiple
                onChange={handleCategoryChange}
                renderValue={(p) =>
                  p.length > 0
                    ? (p.length === categoryList.length ? "All" : p.length) +
                      " " +
                      t("Categories selected")
                    : ""
                }
                input={<InputStyle />}
              >
                <MenuItem>
                  <Checkbox
                    className="pw-emission-check"
                    checked={isCategoryCheckedAll}
                    //indeterminate={!allSelected && selectedCount > 0}
                    onChange={(e: any) => globalSelectChange(e, "category")}
                  />
                  All Categories
                </MenuItem>
                {categoryList.map((each: any) => (
                  <MenuItem value={each.code} key={each.id}>
                    <Checkbox
                      checked={isIdSelected("code", each.code, category)}
                    />
                    {each.code}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          {/* {showDateRange && ( */}
          <RangePicker
            // value={dates || value}
            className="pw-selectbunit"
            picker="month"
            onCalendarChange={(val: any) => {
              setDates(val);
            }}
            onChange={onChangeDate}
            onOpenChange={onOpenChange}
            placeholder={["From", "To"]}
            defaultValue={defaultDateRange}
            format={monthFormat}
          />
          {/* )} */}
        </div>
      </div>
      <div className="pw-dashboard-main-div flex flex-col gap-5 w-full">
        <div className="pw-dashboard-total flex flex-row gap-4 justify-between">
          <div className="pw-total flex flex-row gap-2 flex-1">
            {isLoading ? (
              <DashboardSkeleton type="card" />
            ) : (
              <>
                <div className="pw-total-left-div flex flex-col gap-1">
                  <div className="pw-total-emission text-xs text-neutral-400 font-bold">
                    {t("TOTAL EMISSIONS")}
                  </div>
                  <div className="flex flex-row gap-2 items-center">
                    <p className="text-2xl font-bold text-neutral-900">
                      {getUOMValue(
                        totalEmission.total_emission_value,
                        "kg CO2e",
                        selectedUOM
                      )}
                    </p>
                    <p className="text-sm text-neutral-600 pw-dashboard-text">
                      {selectedUOM}
                    </p>
                  </div>
                </div>
                <div className="pw-total-left-div flex flex-col gap-1">
                  <div className="flex flex-row text-xs text-neutral-400 font-bold">
                    <div>{t("TOTAL CARBON COST")}</div>
                    {/* <div>(in 000's)</div> */}
                  </div>
                  <div className="flex flex-row gap-2 items-center">
                    <p className="text-2xl font-bold text-neutral-900">
                      {carbonPrice > 1000
                        ? round(CarbonPriceValue[0]) + CarbonPriceValue[1]
                        : carbonPrice
                        ? specialRound(carbonPrice)
                        : 0}
                    </p>
                    {carbonPrice !== "" && (
                      <AntSelect
                        className="pw-carbon-cost"
                        style={{ width: 75 }}
                        suffixIcon={
                          <CaretDownOutlined className="!pointer-events-none" />
                        }
                        onBlur={() => setOpenCureencyDropDown(false)}
                        onClick={() =>
                          setOpenCureencyDropDown(!openCurrencyDropdown)
                        }
                        open={openCurrencyDropdown}
                        // showSearch
                        value={currency}
                        onChange={(e) => onChangeCurrency(e)}
                        // onSearch={onSearch}
                        filterOption={(input, option: any) => {
                          let currObj = currencies.find(
                            (opt: any) => opt.id === option.value
                          );
                          return (
                            currObj?.name
                              ?.toLowerCase()
                              ?.includes(input.toLowerCase()) ||
                            currObj?.symbol
                              ?.toLowerCase()
                              ?.includes(input.toLowerCase())
                          );
                        }}
                      >
                        {currencies.map((eachCurrency: any) => (
                          <Option key={eachCurrency.id} value={eachCurrency.id}>
                            {eachCurrency.symbol}
                          </Option>
                        ))}
                      </AntSelect>
                    )}
                  </div>
                </div>
                <div className="flex flex-row gap-2 items-center">
                  <img src="assets/icons/Flight.svg" alt=" " />
                  <div className="text-sm ">
                    {`${t("Your total emission is equivalent to")} ${
                      totalEmission.conversion_value < 1
                        ? totalEmission.conversion_value < 0.5
                          ? t(" 0 Flights ")
                          : t(" about 1 Flight ")
                        : t(" about ") +
                          getUOMValue(
                            totalEmission.conversion_value,
                            "kg CO2e",
                            selectedUOM
                          ) +
                          t(" Flights ")
                    }`}
                    {t("from New York to Los Angeles")}
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="pw-total flex flex-row gap-2 flex-1">
            {isLoading ? (
              <DashboardSkeleton type="card" />
            ) : (
              <>
                <div className="pw-total-right-div !w-auto flex flex-col gap-1 whitespace-nowrap overflow-hidden pr-12">
                  <div className="text-xs text-neutral-400 font-bold">
                    {t("TOTAL OFFSET")}
                  </div>
                  <div className="flex flex-row gap-2 items-center">
                    <p className="text-2xl font-bold text-neutral-900">
                      {getUOMValue(
                        totalOffsetValue.tco2e,
                        "t CO2e",
                        selectedUOM
                      )}
                    </p>
                    <p className="text-sm text-neutral-600">{selectedUOM}</p>
                  </div>
                </div>
                <div className="!w-auto flex flex-col gap- whitespace-nowrap overflow-hidden">
                  <div className="text-xs text-neutral-400 font-bold">
                    {t("TOTAL RENEWABLE ENERGY CONSUMED")}
                  </div>
                  <div className="flex flex-row gap-2 items-center">
                    <p className="text-2xl font-bold text-neutral-900">
                      {getRoundOff(totalOffsetValue.mwh)}
                    </p>
                    <p className="text-sm text-neutral-600 pw-dashboard-text">
                      {"MWh"}
                    </p>
                  </div>
                </div>
                {/* <div className="flex flex-row gap-2 items-center">
                  <img src="assets/icons/Tree.svg" alt=" " />
                  <div className="text-sm ">
                    {t(
                      "Contribution from your organisation is equivalent to planting 0 trees"
                    )}
                  </div>
                </div> */}
              </>
            )}
          </div>
        </div>
        <div className="pw-dashboard-body flex flex-col gap-5">
          <div className="flex flex-row gap-5 justify-between">
            <div
              className="pw-dashboard-scope w-[70%]"
              id="pw-e2e-organisationemissions"
            >
              {isLoading ? (
                <DashboardSkeleton type="graph" />
              ) : (
                <>
                  <div className="pw-dashboard-scope-top flex flex-col gap-1">
                    <p className="text-base font-bold text-neutral-500">
                      {t("Organisation Emissions")}
                    </p>
                    <p className="font-normal text-sm text-neutral-600">
                      {t("Area graph")}
                    </p>
                  </div>
                  {areaGraphOptions.series.length ? (
                    <Chart
                      options={areaGraphOptions.options}
                      series={areaGraphOptions.series}
                      type="area"
                      height={230}
                    />
                  ) : (
                    <ShowNoData />
                  )}
                </>
              )}
            </div>
            <div
              className="pw-dashboard-right flex flex-col gap-5"
              id="pw-e2e-categorycontributions"
            >
              <div className="pw-circle-progress-div flex flex-col  justify-between gap-6">
                {isLoading ? (
                  <DashboardSkeleton type="progress bar" />
                ) : (
                  <>
                    <div className="pw-dashboard-scope-top flex flex-col gap-1">
                      <p className="text-base font-bold text-neutral-500">
                        {t("Contribution")}
                      </p>
                      <p className="font-normal text-sm text-neutral-600">
                        {t(
                          "Top three contributions in Scope 1, Scope 2 & scope 3 respectively"
                        )}
                      </p>
                    </div>
                    {topThreeEmissions.length ? (
                      topThreeEmissions
                        .sort((e1: any, e2: any) => {
                          return (
                            parseFloat(e2.emissionvalue) -
                            parseFloat(e1.emissionvalue)
                          );
                        })
                        .map((eachvalue: any, index: number) => {
                          return index > 2 ? (
                            ""
                          ) : (
                            <div className="flex flex-row gap-2 items-center justify-between">
                              <div className="flex flex-row items-center gap-2">
                                <CircularProgressBar
                                  style={{ color: progressColor[index] }}
                                  value={parseFloat(eachvalue.progress)}
                                />
                                <Tooltip title={eachvalue.name}>
                                  <div className="flex flex-col gap-1">
                                    <p className="text-sm text-neutral-900">
                                      {eachvalue.category}
                                    </p>
                                    {localStorage.getItem("protocol") ==
                                    "ghg" ? (
                                      ""
                                    ) : (
                                      <p className="text-xs text-neutral-600">
                                        {scopeMap[eachvalue.scope]}
                                      </p>
                                    )}
                                  </div>
                                </Tooltip>
                              </div>
                              <div className="flex flex-col gap-1 items-end">
                                <p className=" text-neutral-900 font-bold text-right">
                                  {getUOMValue(
                                    eachvalue.emissionvalue,
                                    "kg CO2e",
                                    selectedUOM
                                  )}
                                  &nbsp;
                                  {selectedUOM}
                                </p>
                              </div>
                            </div>
                          );
                        })
                    ) : (
                      <ShowNoData />
                    )}
                  </>
                )}
              </div>
              {/* 
            <div className="pw-circle-progress-div pw-side-height w-full h-full flex flex-col gap-3 ">
              <div className="flex flex-row justify-between pb-4">
                <p className="text-neutral-900 font-bold">To Do / Reminders</p>
                <CircleIcon style={{ color: primaryColor }} />
              </div>
              <div className="pw-status-list bg-white pb-4 flex flex-row gap-2 ">
                <CircleOutlinedIcon style={{ color: neutral[400] }} />
                <div className="flex flex-col gap-2">
                  <p className="text-sm flex flex-row">
                    Approval For log by &nbsp;
                    <p className="font-bold">Jane Cooper</p>
                  </p>
                  <div className="flex flex-row gap-2 items-center">
                    <p className="text-xs">24 April 2023</p>
                    <div className="pw-task-status bg-warning-100 text-warning-500 text-semibold">
                      Pending
                    </div>
                    <FlagIcon style={{ color: neutral[300] }} />
                  </div>
                </div>
              </div>
              <div className="pw-status-list bg-white pb-4 flex flex-row gap-2 ">
                <TaskAltOutlinedIcon style={{ color: primaryColor }} />
                <div className="flex flex-col gap-2">
                  <p className="text-sm flex flex-row">
                    Approval For log by &nbsp;
                    <p className="font-bold">Wayne Murphy</p>
                  </p>
                  <div className="flex flex-row gap-2 items-center">
                    <p className="text-xs">24 April 2023</p>
                    <div className="pw-task-status bg-success-100 text-success font-semibold">
                      Confirmed
                    </div>
                  </div>
                </div>
              </div>
              <div className="pw-status-list bg-white pb-4 flex flex-row gap-2 ">
                <TaskAltOutlinedIcon style={{ color: primaryColor }} />
                <div className="flex flex-col gap-2">
                  <p className="text-sm flex flex-row">
                    Approval For log by &nbsp;
                    <p className="font-bold">Laura Brooks</p>
                  </p>
                  <div className="flex flex-row gap-2 items-center">
                    <p className="text-xs">24 April 2023</p>
                    <div className="pw-task-status bg-success-100 text-success font-semibold">
                      Confirmed
                    </div>
                  </div>
                </div>
              </div>
              <div className="pw-status-list bg-white pb-4 flex flex-row gap-2 ">
                <CancelOutlinedIcon style={{ color: error[500] }} />
                <div className="flex flex-col gap-2">
                  <p className="text-sm flex flex-row">
                    Approval For log by &nbsp;
                    <p className="font-bold">Jane Cooper</p>
                  </p>
                  <div className="flex flex-row gap-2 items-center">
                    <p className="text-xs">24 April 2023</p>
                    <div className="pw-task-status bg-error-100 text-error-500 font-semibold">
                      Rejected
                    </div>
                  </div>
                </div>
              </div>
              <div className="pw-status-list bg-white pb-4 flex flex-row gap-2 ">
                <TaskAltOutlinedIcon style={{ color: primaryColor }} />
                <div className="flex flex-col gap-2">
                  <p className="text-sm flex flex-row">
                    Approval For log by &nbsp;
                    <p className="font-bold">Jane Cooper</p>
                  </p>
                  <div className="flex flex-row gap-2 items-center">
                    <p className="text-xs">24 April 2023</p>
                    <div className="pw-task-status bg-success-100 text-success font-semibold">
                      Confirmed
                    </div>
                  </div>
                </div>
              </div>
              <div className="pw-status-list bg-white pb-4 flex flex-row gap-2 ">
                <TaskAltOutlinedIcon style={{ color: primaryColor }} />
                <div className="flex flex-col gap-2">
                  <p className="text-sm flex flex-row">
                    Approval For log by &nbsp;
                    <p className="font-bold">Robert Fox</p>
                  </p>
                  <div className="flex flex-row gap-2 items-center">
                    <p className="text-xs">24 April 2023</p>
                    <div className="pw-task-status bg-success-100 text-success font-semibold">
                      Confirmed
                    </div>
                  </div>
                </div>
              </div>
              <div className="pw-status-list bg-white pb-4 flex flex-row gap-2 ">
                <CircleOutlinedIcon style={{ color: neutral[400] }} />
                <div className="flex flex-col gap-2">
                  <p className="text-sm flex flex-row">
                    Approval For log by &nbsp;
                    <p className="font-bold">Karen John</p>
                  </p>
                  <div className="flex flex-row gap-2 items-center">
                    <p className="text-xs">24 April 2023</p>
                    <div className="pw-task-status bg-warning-100 text-warning-500 font-semibold">
                      Pending
                    </div>
                  </div>
                </div>
              </div>
              <div className="pw-status-list bg-white pb-4 flex flex-row gap-2 ">
                <CancelOutlinedIcon style={{ color: error[500] }} />
                <div className="flex flex-col gap-2">
                  <p className="text-sm flex flex-row">
                    Approval For log by &nbsp;
                    <p className="font-bold">Thomas Henry</p>
                  </p>
                  <div className="flex flex-row gap-2 items-center">
                    <p className="text-xs">24 April 2023</p>
                    <div className="pw-task-status bg-error-100 text-error-500 font-semibold">
                      Rejected
                    </div>
                  </div>
                </div>
              </div>
              <div className="pw-status-list bg-white pb-4 flex flex-row gap-2 ">
                <CircleOutlinedIcon style={{ color: neutral[400] }} />
                <div className="flex flex-col gap-2">
                  <p className="text-sm flex flex-row">
                    Approval For log by &nbsp;
                    <p className="font-bold">Karen John</p>
                  </p>
                  <div className="flex flex-row gap-2 items-center">
                    <p className="text-xs">24 April 2023</p>
                    <div className="pw-task-status bg-warning-100 text-warning-500 font-semibold">
                      Pending
                    </div>
                  </div>
                </div>
              </div>
            </div>
          */}
            </div>
          </div>
          <div
            className="pw-dashboard-scope flex flex-col justify-between"
            id="pw-e2e-emissionsbreakdown"
          >
            {isLoading ? (
              <DashboardSkeleton type="graph" />
            ) : (
              <>
                <div className="pw-dashboard-scope-top flex flex-row justify-between gap-1">
                  <div className="flex flex-col gap-1">
                    <p className="text-base text-neutral-500 font-bold text-base">
                      {t("Emissions Breakdown")}
                    </p>
                    <p className="text-sm text-neutral-600">
                      {t("Sub category graph")}
                    </p>
                  </div>
                  <div className="flex items-start">
                    <FormControl
                      className="pw-scope-dropdown !text-sm text-neutral-600 font-bold"
                      size="small"
                      style={{ background: neutral[100] }}
                    >
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={scope}
                        onChange={handleScopeChange}
                      >
                        <MenuItem value={4}>{t("All Scopes")}</MenuItem>
                        <MenuItem value={1}>{t("Scope 1")}</MenuItem>
                        <MenuItem value={2}>{t("Scope 2")}</MenuItem>
                        <MenuItem value={3}>{t("Scope 3")}</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
                {barOptions.series.length ? (
                  <Chart
                    options={barOptions.options}
                    series={barOptions.series}
                    type="bar"
                    height={350}
                  />
                ) : (
                  <ShowNoData />
                )}
              </>
            )}
          </div>
        </div>
        <div className="pw-dashboard-scope" id="pw-e2e-categoryemissions">
          {isLoading ? (
            <DashboardSkeleton type="graph" />
          ) : (
            <>
              <div className="pw-dashboard-scope-top flex flex-col gap-1">
                <p className="text-base font-bold text-neutral-500">
                  {t("Category Emissions")}
                </p>
                <p className="font-normal text-sm text-neutral-600">
                  {t("Sankey chart")}
                </p>
              </div>
              <div className="flex flex-col items-center pt-2">
                {data3?.length > 1 ? (
                  <SankeyChart data={data3} />
                ) : (
                  // <DoubleDonutGraph graphData={data3} />
                  <ShowNoData />
                )}
              </div>
            </>
          )}
        </div>
        <div
          className="flex flex-col items-start pw-dashboard-scope pw-horizontal-width gap-2"
          id="pw-e2e-emissionsbyfacilities"
        >
          {isLoading ? (
            <DashboardSkeleton type="graph" />
          ) : (
            <>
              <div className="flex ">
                <div className="pw-dashboard-scope-top flex flex-col gap-2 w-full">
                  <p className="text-base font-bold text-neutral-500">
                    {t("Emissions by Facilities")}
                  </p>
                  <p className="font-normal text-sm text-neutral-600">
                    {t(
                      "Scope-wise total GHG emissions across the facilities of the organization"
                    )}
                  </p>
                </div>
              </div>

              <div
                className={`w-full ${
                  horizontalBarOptions.series[0].data.length > 7 &&
                  "pw-graph-container"
                }`}
              >
                {horizontalBarOptions.series[0].data.length ? (
                  <Chart
                    options={horizontalBarOptions.options}
                    series={horizontalBarOptions.series}
                    type="bar"
                    height={
                      horizontalBarOptions.series[0].data.length > 7
                        ? horizontalBarOptions.series[0].data.length * 38
                        : 350
                    }
                  />
                ) : (
                  <ShowNoData />
                )}
              </div>
            </>
          )}
        </div>
        <div className="pw-dashboard-scope flex flex-col">
          {isLoading ? (
            <DashboardSkeleton type="graph" />
          ) : (
            <>
              <div className="pw-dashboard-scope-top flex flex-row gap-1 justify-between">
                {showList ? (
                  <p className="text-base font-bold text-neutral-500">
                    {t("Targets")}
                  </p>
                ) : (
                  <>
                    <TabContext value={currentTab}>
                      <Box
                      // sx={{
                      //   borderBottom: 1,
                      //   borderColor: "divider",
                      //   width: "fit-content",
                      // }}
                      >
                        <TabList
                          onChange={handleTabChange}
                          className="pw-supplier-tabs"
                        >
                          <Tab
                            value="1"
                            sx={{
                              fontWeight:
                                currentTab == "1" ? "bold" : "regular",
                            }}
                            label="Facility"
                          />
                          <Tab
                            value="2"
                            sx={{
                              fontWeight:
                                currentTab == "2" ? "bold" : "regular",
                            }}
                            label="Scope"
                          />
                          <Tab
                            value="3"
                            sx={{
                              fontWeight:
                                currentTab == "3" ? "bold" : "regular",
                            }}
                            label="Category"
                          />
                        </TabList>
                      </Box>
                      <TabPanel value="1"></TabPanel>
                      <TabPanel value="2"></TabPanel>
                      <TabPanel value="3"></TabPanel>
                    </TabContext>
                  </>
                )}

                {/* <TabContext value={currentTab}>
                  <Box
                    sx={{
                      borderBottom: 1,
                      borderColor: "divider",
                      width: "fit-content",
                    }}
                  >
                    <TabList
                      onChange={handleTabChange}
                      className="pw-supplier-tabs"
                    >
                      <Tab
                        value="1"
                        sx={{
                          fontWeight: currentTab == "1" ? "bold" : "regular",
                        }}
                        label="Facility"
                      />
                      <Tab
                        value="2"
                        sx={{
                          fontWeight: currentTab == "2" ? "bold" : "regular",
                        }}
                        label="Scope"
                      />
                      <Tab
                        value="3"
                        sx={{
                          fontWeight: currentTab == "3" ? "bold" : "regular",
                        }}
                        label="Category"
                      />
                    </TabList>
                  </Box>
                  <TabPanel value="1"></TabPanel>
                  <TabPanel value="2"></TabPanel>
                  <TabPanel value="3"></TabPanel>
                </TabContext> */}

                {/* const renderCategoryRows = () => {
    const categories = categoryData.get(year) || []; //categoryData.get(year) || [];
     */}

                <div className="flex flex-row gap-3">
                  <div className="flex flex-row items-center mb-5">
                    <img
                      className="cursor-pointer"
                      src={
                        showList
                          ? "assets/icons/list-selected.svg"
                          : "assets/icons/list.svg"
                      }
                      onClick={() => {
                        setShowList(true);
                        setCurrentTab("1");
                        setCurrentTabName("Facility");
                        getTabularData();
                      }}
                      alt=" "
                    />
                    <img
                      className="cursor-pointer"
                      src={
                        !showList
                          ? "assets/icons/graph-selected.svg"
                          : "assets/icons/graph-notSelected.svg"
                      }
                      onClick={() => {
                        setShowList(false);
                      }}
                      alt=" "
                    />
                  </div>
                  {currentTab === "2" && !showList && (
                    <>
                      {scopes.length ? (
                        <AntSelect
                          suffixIcon={
                            <CaretDownOutlined className="!pointer-events-none mb-5" />
                          }
                          dropdownStyle={{ minWidth: "8%" }}
                          showSearch
                          style={{ width: 120 }}
                          className="pw-target-bunit cursor-pointer"
                          placeholder={t("Select Scope")}
                          value={scopeType}
                          onChange={(e) => onChangeScope(e)}
                        >
                          {scopes.map(
                            ({ name, id }: { name: string; id: number }) => (
                              <Option
                                key={id}
                                value={id}
                                className="pw-menu-item"
                              >
                                {name}
                              </Option>
                            )
                          )}
                        </AntSelect>
                      ) : null}
                    </>
                  )}
                  {currentTab === "3" && !showList && (
                    <>
                      {categoryList.length ? (
                        <AntSelect
                          suffixIcon={
                            <CaretDownOutlined className="!pointer-events-none mb-5" />
                          }
                          dropdownStyle={{ minWidth: "20%" }}
                          showSearch
                          style={{ width: 150 }}
                          className="pw-target-bunit cursor-pointer"
                          placeholder={t("Select Category")}
                          value={categoryType}
                          onChange={(e) => onChangeCategory(e)}
                        >
                          {categoryList.map(
                            ({ id, code }: { id: number; code: any }) => (
                              <Option
                                key={id}
                                value={id}
                                className="pw-menu-item"
                              >
                                {code}
                              </Option>
                            )
                          )}
                        </AntSelect>
                      ) : null}
                    </>
                  )}
                  {bunitListWithTargets?.length ? (
                    <AntSelect
                      suffixIcon={
                        <CaretDownOutlined className="!pointer-events-none mb-5" />
                      }
                      dropdownStyle={{ minWidth: "25%" }}
                      showSearch
                      style={{ width: 200 }}
                      className="pw-target-bunit"
                      placeholder={t("Select Facility")}
                      value={targetBunit}
                      onChange={(e) => onChangeTargetUnit(e)}
                    >
                      {bunitListWithTargets?.map(
                        ({ name, id }: { name: String; id: number }) => (
                          <Option key={id} value={id} className="pw-menu-item">
                            {name}
                          </Option>
                        )
                      )}
                    </AntSelect>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="pw-target-top mt-2"></div>
              {!showList ? (
                <div className="flex flex-row pw-width-100 pw-justify-space-between">
                  <div
                    className="pw-dashboard-scope pw-target-chart"
                    id="pw-e2e-target-chart"
                  >
                    <div className="pw-dashboard-scope-top flex flex-col gap-1 h-12">
                      <p className="text-base font-semibold text-neutral-600">
                        {t("Absolute emissions targets")}
                      </p>
                    </div>
                    <div className="flex flex-col items-center pt-2 pw-target-graph">
                      {targetOptions.series[0].data?.length &&
                      bunitListWithTargets?.length ? (
                        <Chart
                          options={targetOptions.options}
                          series={targetOptions.series}
                          type="line"
                          height={230}
                          width={400}
                        />
                      ) : (
                        <ShowNoData />
                      )}
                    </div>
                  </div>
                  <div
                    className="pw-target-seperator"
                    id="pw-e2e-targetintensityratio"
                  ></div>
                  <div className="pw-dashboard-scope pw-target-chart">
                    <div className="pw-dashboard-scope-top flex flex-col gap-1 h-12">
                      <div className="flex flex-row justify-between gap-3">
                        <p className="pw-intensity-dashboard text-base font-semibold text-neutral-600">
                          {t("Emission intensity ratio target")}
                        </p>

                        <AntSelect
                          suffixIcon={
                            <CaretDownOutlined className="!pointer-events-none" />
                          }
                          dropdownStyle={{ minWidth: "25%" }}
                          showSearch
                          style={{ width: 180 }}
                          className="pw-target-bunit"
                          placeholder="Select Metric Type"
                          value={metric}
                          onChange={(e) => onChangeMetric(e)}
                        >
                          {metrics?.map((eachMetric: string, index: number) => (
                            <Option
                              key={index}
                              value={eachMetric}
                              className="pw-menu-item"
                            >
                              {eachMetric}
                            </Option>
                          ))}
                        </AntSelect>
                      </div>
                    </div>
                    <div className="flex flex-col items-center pt-2">
                      {data3.length && bunitListWithTargets?.length ? (
                        <Chart
                          options={targetMetricsOptions.options}
                          series={targetMetricsOptions.series}
                          type="line"
                          height={230}
                          width={400}
                        />
                      ) : (
                        <ShowNoData />
                      )}
                    </div>
                  </div>
                </div>
              ) : dataPresent ? (
                <>
                  <TableContainer className="pw-dashboard-content">
                    <Table>
                      <TableHead>
                        <TableRow className="!bg-neutral-50 ">
                          <TableCell className="!text-neutral-600">
                            {t("Category")}
                          </TableCell>
                          <TableCell
                            align="center"
                            colSpan={2}
                            className="!bg-info-100 !p-1 !text-sm !text-neutral-600"
                          >
                            {t("Emissions")} ({selectedUOM})
                          </TableCell>
                          {targetCategories.map(
                            (year: string | number, index: number) => (
                              <TableCell key={index} colSpan={2} align="center">
                                {year}
                              </TableCell>
                            )
                          )}
                        </TableRow>
                        <TableRow>
                          <TableCell className="!bg-neutral-50" />
                          <TableCell
                            align="center"
                            className="!bg-info-100 !text-sm !text-neutral-600"
                          >
                            Actual
                          </TableCell>
                          <TableCell
                            align="center"
                            className="!bg-info-100 !text-sm !text-neutral-600"
                          >
                            Target
                          </TableCell>
                          {targetCategories.map((index: number) => (
                            <React.Fragment key={index}>
                              <TableCell
                                align="center"
                                className="!bg-neutral-50 !text-sm !text-neutral-600"
                              >
                                Actual
                              </TableCell>
                              <TableCell
                                align="center"
                                className="!bg-neutral-50 !text-sm !text-neutral-600"
                              >
                                Target
                              </TableCell>
                            </React.Fragment>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {categoryList.map((eachCategory: any) => {
                          return (
                            <React.Fragment key={eachCategory.id}>
                              {eachCategory.code ===
                                CATEGORY_CODE.CATEGORY_1_1 &&
                                renderScopeRow(1, "Scope 1")}
                              {eachCategory.code ===
                                CATEGORY_CODE.CATEGORY_2_1 &&
                                renderScopeRow(2, "Scope 2")}
                              {eachCategory.code ===
                                CATEGORY_CODE.CATEGORY_3_1 &&
                                renderScopeRow(3, "Scope 3")}

                              {emissionsData ? (
                                <TableRow>
                                  <TableCell className="pw-table-cat !pl-8">
                                    {eachCategory.code} {eachCategory.name}
                                  </TableCell>
                                  <TableCell
                                    className="!bg-info-100"
                                    align="right"
                                  >
                                    {getUOMValue(
                                      emissionsData?.actuals.categories.find(
                                        (cat: { id: any }) =>
                                          cat.id === eachCategory.id
                                      )?.total_value || 0,
                                      "t CO2e",
                                      selectedUOM
                                    )}
                                  </TableCell>
                                  <TableCell
                                    className="!bg-info-100"
                                    align="right"
                                  >
                                    {getUOMValue(
                                      emissionsData?.targets.categories.find(
                                        (cat: { category: any }) =>
                                          cat.category === eachCategory.id
                                      )?.total_value || 0,
                                      "t CO2e",
                                      selectedUOM
                                    )}
                                  </TableCell>
                                  {targetCategories?.map(
                                    (year: number, index: number) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <TableCell align="right">
                                            {year > new Date().getFullYear()
                                              ? "-"
                                              : getUOMValue(
                                                  emissionsData?.actuals.categories.find(
                                                    (cat: { id: any }) =>
                                                      cat.id === eachCategory.id
                                                  )?.data[
                                                    year as keyof (typeof emissionsData.actuals.categories)[0]["data"]
                                                  ] || 0,
                                                  "t CO2e",
                                                  selectedUOM
                                                )}
                                          </TableCell>
                                          <TableCell align="right">
                                            {getUOMValue(
                                              emissionsData?.targets.categories.find(
                                                (cat: { category: any }) =>
                                                  cat.category ===
                                                  eachCategory.id
                                              )?.data[
                                                year as keyof (typeof emissionsData.targets.categories)[0]["data"]
                                              ] || 0,
                                              "t CO2e",
                                              selectedUOM
                                            )}
                                          </TableCell>
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                                </TableRow>
                              ) : (
                                ""
                              )}
                            </React.Fragment>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              ) : (
                <ShowNoData />
              )}
            </>
          )}
        </div>
        <div className="pw-dashboard-table">
          <div className="pl-7 py-4 flex flex-col items-start gap-1">
            <p className="font-bold">{t("Emission by Category")}</p>
            <p className="font-normal text-sm text-neutral-600">
              {t(
                "Distribution of total GHG emissions against the sub-categories of each scope"
              )}
            </p>
          </div>
          {monthsArray.length || emissionByMonth.length ? (
            <TableContainer className="pw-dashboard-content">
              <Table>
                <TableHead>
                  <TableRow className="!bg-neutral-50 ">
                    <TableCell className="!text-neutral-600">
                      {t("Category")}
                    </TableCell>
                    <TableCell
                      align="center"
                      className="!bg-info-100 !p-1 !text-sm !text-neutral-600"
                    >
                      {t("Total")} ({selectedUOM})
                    </TableCell>
                    {/* <TableCell align="right" className="!bg-info-100">%</TableCell> */}

                    {Object.keys(yearsMap)?.length ? (
                      Object.keys(yearsMap).map((eachYear: any) =>
                        monthsArray
                          .filter(
                            (_: String, index: number) =>
                              startMonth.getMonth() +
                                startMonth.getFullYear() * 12 <=
                                index + 12 * eachYear &&
                              endMonth.getMonth() +
                                endMonth.getFullYear() * 12 >
                                index + 12 * eachYear
                          )
                          .map((month: any) => (
                            <TableCell
                              align="right"
                              className="!text-neutral-600"
                            >
                              {month}-{eachYear}
                            </TableCell>
                          ))
                      )
                    ) : (
                      <TableCell
                        align="right"
                        className="!text-neutral-600"
                      ></TableCell>
                    )}
                  </TableRow>
                </TableHead>
                {emissionByMonth &&
                  emissionByMonth?.t1?.map((eachScope: any) => (
                    <Fragment>
                      <TableHead>
                        <TableRow className="!bg-neutral-100">
                          <TableCell className="pw-table-cat">
                            <p className="text-neutral-600 ">
                              {eachScope.code} {eachScope.name}
                            </p>
                          </TableCell>
                          <TableCell
                            align="right"
                            className="!bg-info-100 pw-table-total"
                          >
                            <div className="flex flex-col gap-1">
                              <p className="font-bold text-neutral-600 ">
                                {getUOMValue(
                                  eachScope.total_value,
                                  "kg CO2e",
                                  selectedUOM
                                )}
                              </p>
                              <p className="!text-xs text-neutral-600 ">
                                {totalEmission?.total_emission_value
                                  ? round(
                                      (eachScope.total_value * 100) /
                                        totalEmission.total_emission_value
                                    )
                                  : "-"}{" "}
                                %
                              </p>
                            </div>
                          </TableCell>
                          {/* <TableCell
                          align="right"
                          style={{  }}
                          className="!bg-info-100"
                        >
                          <p className="font-bold text-neutral-600 ">
                            {totalEmission?.total_emission_value
                              ? (
                                  (eachScope.total_value * 100) /
                                  totalEmission.total_emission_value
                                ).toFixed(2)
                              : "-"}
                          </p>
                        </TableCell> */}
                          {Object.keys(yearsMap)?.length &&
                            Object.keys(yearsMap).map((eachYear: any) =>
                              monthsArray
                                .filter(
                                  (_: String, index: number) =>
                                    startMonth.getMonth() +
                                      startMonth.getFullYear() * 12 <=
                                      index + 12 * eachYear &&
                                    endMonth.getMonth() +
                                      endMonth.getFullYear() * 12 >
                                      index + 12 * eachYear
                                )
                                .map((month: any) => (
                                  <TableCell
                                    align="right"
                                    className="pw-table-month"
                                  >
                                    <div className="flex flex-col gap-1">
                                      {eachScope.data[month + "-" + eachYear] !=
                                      null ? (
                                        <p className="font-bold text-neutral-600">
                                          {getUOMValue(
                                            eachScope.data[
                                              month + "-" + eachYear
                                            ],
                                            "kg CO2e",
                                            selectedUOM
                                          )}
                                        </p>
                                      ) : (
                                        <p className="font-bold text-neutral-600">
                                          -
                                        </p>
                                      )}
                                      <p className="!text-xs text-neutral-600 ">
                                        {totalEmission?.total_emission_value &&
                                        eachScope.data[
                                          month + "-" + eachYear
                                        ] != null
                                          ? `${round(
                                              (eachScope.data[
                                                month + "-" + eachYear
                                              ] *
                                                100) /
                                                totalEmission.total_emission_value
                                            )}%`
                                          : " "}{" "}
                                      </p>
                                    </div>
                                  </TableCell>
                                ))
                            )}
                        </TableRow>
                      </TableHead>

                      {emissionByMonth &&
                        emissionByMonth?.t2
                          ?.filter(
                            (eachCategory: any) =>
                              eachCategory.parent === eachScope.id
                          )
                          .map((eachCategory: any) => (
                            <>
                              <TableBody>
                                <TableRow>
                                  <TableCell className="pw-table-cat !pl-8">
                                    <p className="text-neutral-900">
                                      {localStorage.getItem("protocol") == "iso"
                                        ? eachCategory.code
                                            .split(" ")[0]
                                            .substring(0, 3)
                                        : eachCategory.code.split(" ")[0]}{" "}
                                      {eachCategory.code.split(" ")[1]}{" "}
                                      {eachCategory.name}
                                    </p>
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className="!bg-info-100"
                                  >
                                    <div className="flex flex-col gap-1">
                                      <p className="font-bold">
                                        {getUOMValue(
                                          eachCategory.total_value,
                                          "kg CO2e",
                                          selectedUOM
                                        )}
                                      </p>
                                      <p className="!text-xs text-neutral-600 ">
                                        {totalEmission?.total_emission_value
                                          ? round(
                                              (eachCategory.total_value * 100) /
                                                totalEmission.total_emission_value
                                            )
                                          : "-"}{" "}
                                        %
                                      </p>
                                    </div>
                                  </TableCell>
                                  {/* <TableCell
                                  align="right"
                                  style={{  }}
                                  className="!bg-info-100"
                                >
                                  <p className="font-bold text-neutral-600 ">
                                    {totalEmission?.total_emission_value
                                      ? (
                                          (eachCategory.total_value * 100) /
                                          totalEmission.total_emission_value
                                        ).toFixed(2)
                                      : "-"}
                                  </p>
                                </TableCell> */}
                                  {Object.keys(yearsMap)?.length &&
                                    Object.keys(yearsMap).map((eachYear: any) =>
                                      monthsArray
                                        .filter(
                                          (_: String, index: number) =>
                                            startMonth.getMonth() +
                                              startMonth.getFullYear() * 12 <=
                                              index + 12 * eachYear &&
                                            endMonth.getMonth() +
                                              endMonth.getFullYear() * 12 >
                                              index + 12 * eachYear
                                        )
                                        .map((month: any) => (
                                          <TableCell
                                            align="right"
                                            className="pw-table-month"
                                          >
                                            <div className="flex flex-col gap-1">
                                              {eachCategory.data[
                                                month + "-" + eachYear
                                              ] != null ? (
                                                <p className="font-bold text-neutral-600">
                                                  {getUOMValue(
                                                    eachCategory.data[
                                                      month + "-" + eachYear
                                                    ],
                                                    "kg CO2e",
                                                    selectedUOM
                                                  )}
                                                </p>
                                              ) : (
                                                <p className="font-bold text-neutral-600">
                                                  -
                                                </p>
                                              )}
                                              <p className="!text-xs text-neutral-600 ">
                                                {totalEmission?.total_emission_value &&
                                                eachCategory.data[
                                                  month + "-" + eachYear
                                                ] != null
                                                  ? `${round(
                                                      (eachCategory.data[
                                                        month + "-" + eachYear
                                                      ] *
                                                        100) /
                                                        totalEmission.total_emission_value
                                                    )}%`
                                                  : " "}{" "}
                                              </p>
                                            </div>
                                          </TableCell>
                                        ))
                                    )}
                                </TableRow>
                                {emissionByMonth &&
                                  emissionByMonth?.t3
                                    ?.filter(
                                      (eachSubCategory: any) =>
                                        eachSubCategory.parent ===
                                        eachCategory.id
                                    )
                                    .map((eachSubCategory: any) => (
                                      <TableRow>
                                        <TableCell className="pw-table-cat !pl-12">
                                          <p className="">
                                            {eachSubCategory.code
                                              .split(" ")[0]
                                              .substring(0, 3)}{" "}
                                            {eachSubCategory.code.split(" ")[1]}{" "}
                                            {eachSubCategory.name}
                                          </p>
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          className="!bg-info-100"
                                        >
                                          <div className="flex flex-col gap-1">
                                            <p className="font-bold">
                                              {getUOMValue(
                                                eachSubCategory.total_value,
                                                "kg CO2e",
                                                selectedUOM
                                              )}
                                            </p>
                                            <p className="!text-xs text-neutral-600 ">
                                              {totalEmission?.total_emission_value
                                                ? round(
                                                    (eachSubCategory.total_value *
                                                      100) /
                                                      totalEmission.total_emission_value
                                                  )
                                                : "-"}{" "}
                                              %
                                            </p>
                                          </div>
                                        </TableCell>
                                        {/* <TableCell
                                        align="right"
                                        style={{  }}
                                        className="!bg-info-100"
                                      >
                                        <p className="!text-xs text-neutral-600 ">
                                          {totalEmission?.total_emission_value
                                            ? (
                                                (eachSubCategory.total_value *
                                                  100) /
                                                totalEmission.total_emission_value
                                              ).toFixed(2)
                                            : "-"}
                                        </p>
                                      </TableCell> */}
                                        {Object.keys(yearsMap)?.length &&
                                          Object.keys(yearsMap).map(
                                            (eachYear: any) =>
                                              monthsArray
                                                .filter(
                                                  (_: String, index: number) =>
                                                    startMonth.getMonth() +
                                                      startMonth.getFullYear() *
                                                        12 <=
                                                      index + 12 * eachYear &&
                                                    endMonth.getMonth() +
                                                      endMonth.getFullYear() *
                                                        12 >
                                                      index + 12 * eachYear
                                                )
                                                .map((month: any) => (
                                                  <TableCell
                                                    align="right"
                                                    className="pw-table-month"
                                                  >
                                                    <div className="flex flex-col gap-1">
                                                      {eachSubCategory.data[
                                                        month + "-" + eachYear
                                                      ] != null ? (
                                                        <p className="font-bold text-neutral-600">
                                                          {getUOMValue(
                                                            eachSubCategory
                                                              .data[
                                                              month +
                                                                "-" +
                                                                eachYear
                                                            ],
                                                            "kg CO2e",
                                                            selectedUOM
                                                          )}
                                                        </p>
                                                      ) : (
                                                        <p className="font-bold text-neutral-600">
                                                          -
                                                        </p>
                                                      )}
                                                      <p className="!text-xs text-neutral-600 ">
                                                        {totalEmission?.total_emission_value &&
                                                        eachSubCategory.data[
                                                          month + "-" + eachYear
                                                        ] != null
                                                          ? `${round(
                                                              (eachSubCategory
                                                                .data[
                                                                month +
                                                                  "-" +
                                                                  eachYear
                                                              ] *
                                                                100) /
                                                                totalEmission.total_emission_value
                                                            )}%`
                                                          : " "}{" "}
                                                      </p>
                                                    </div>
                                                  </TableCell>
                                                ))
                                          )}
                                      </TableRow>
                                    ))}
                              </TableBody>
                            </>
                          ))}
                    </Fragment>
                  ))}
              </Table>
            </TableContainer>
          ) : (
            <ShowNoData />
          )}
        </div>
      </div>
    </div>
  );
}

export default DashBoard;
